export default {

    
    seleccionaNegocio:"Hautatu negozioa...",
    filtraPorEtiqueta:"Etiketa bidezko iragazketa",

    noEncontramosResultadosPara:"Ez dugu emaitzarik ",
    mostrando:"Erakusten",
    resultado:"emaitza",
    resultados:"emaitzak",

    //ALMACÉN
    totalAlmacen:"Biltegia guztira",
    totalAlmacenDto:"Deskontu biltegiaren guztizkoa",
    existenciasTeoricas:"Izakin teorikoak",
    diferencia:"Aldea",
    noContabilizado:"Kontabilizatu gabea",

    seleccioneUnaFechaDeInicioYUnaFechaDeFin:"Hautatu hasiera data eta amaiera data",

    //INFORMES
    inicio: "Hasi",
    informes: "Txostenak",
    productos: "Produktuak",
    ventasPorNegocio: "Salmentak negozioko",
    casas: "Etxeak",
    facturasSimplificadas: "Faktura sinplifikatuak",
    comprasPorNegocio: "Faktura sinplifikatuak",
    comprasPorCasas: "Erosketak etxeka",
    gastosPorProveedor: "Gastuak hornitzailez",
    gastosPorSubproductos: "Lehengaien gastuak",

    //CASAS
    nuevaCasa: "Etxe berria",
    casa: "Etxea",
    negocio: "Negozioa",
    desde: "Noiztik",
    hasta: "Noiz arte",
    consultar: "Kontsultatu",
    infoCasas: "Etxe kontsumo hori aukeratutako data tartean sartutako gastuetatik dator",
    exportarInforme: "Esportatu txostena",
    exportarPdf: "Esportatu PDF gisa",
    exportarExcel: "Excel gisa esportatu",
    exportarExcelSinSubproductos: "Excel gisa esportatu lehengaiekin",

    //TABLA
    fecha: "Data",
    subproductos: "Lehengaiak",
    subproducto: "Lehengaia",
    unidades: "Unitateak",
    partes: "Zatiak",
    precio: "Prezioa",
    total: "Guztira",
    infoConsumo: "Etxe kontsumo hori aukeratutako data tartean sartutako gastuetatik dator",
    noHay: "Ez dago",
    gastos: "Gastuak",
    rangoDeFechas: "data tarte honetan.",
    configuracion: "Konfigurazioa",
    datosFiscales: "Datu fiskalak",

    // DATOS FISCALES
    nombreFiscal: "Izen fiskala",

    //FORM CASA
    nombreCasa: "Etxe izena",
    cifNif: "IFK IFZ",
    direccion: "Helbidea",
    provincia: "Probintzia",
    ciudad: "Hiria",
    codigoPostal: "Kode postala",
    pais: "Herrialdea",
    telefono: "Telefonoa",
    correoElectronico: "Posta elektronikoa",
    baja: "Baja eman",
    guardar: "Gorde",
    cancelar: "Ezeztatu",
    replicar: "Beste negozio batzuetan erreplikatu",
    replicarCasa: "Etxea beste negozio batzuetan kopiatu",
    seleccionarTodos: "Denak hautatu",
    aceptar: "Onartu",
    casaMin: "etxeak",

    //
    compras: "Erosketa",
    agregarCasa: "Gehitu etxea",
    email: "Emaila",
    acciones: "Ekintzak",
    editar: "Editatu",
    enEsteNegocio: "negozio honetan.",

    //PLACEHOLDER
    introduzcaNombre: "Sartu izena",
    introduzcaCifNif: "Sartu IFK / IFZ",
    introduzcaDireccion: "Sartu helbidea",
    introduzcaProvincia: "Sartu probintzia",
    introduzcaCiudad: "Sartu hiria",
    introduzcaCodigoPostal: "Sartu kode postala",
    introduzcaTelefono: "Sartu telefonoa",
    introduzcaCorreo: "Sartu posta elektronikoa",
    buscar: "Bilatu...",

    //PROVEEDORES
    proveedores: "Hornitzaileak",
    agregarProveedor: "Gehitu hornitzailea",
    proveedor: "Hornitzailea",
    categoria: "Kategoria",
    proveedoresMin: "hornitzaileak",

    //FORM
    nombreProveedor: "Hornitzailearen izena",
    acreedor: "Hartzekoduna",
    infoAcreedor: "(Hornitzaile bat hartzekoduna bada, ez da Numier TPVn agertuko)",
    replicarProveedor: "Erreproduzitu hornitzailea beste negozio batzuetan",
    category: "Kategoria",
    replicarCategory: "Etiketa beste negozio batzuetan kopiatu",

    //ETIQUETAS
    etiquetas: "Etiketak",
    etiqueta: "Etiketa",
    sinEtiqueta: "Etiketarik gabe",
    nuevaEtiqueta: "Etiketa berria",
    agregarEtiqueta: "Etiketa gehitu",
    tipo: "Mota",
    etiquetaPadre: "Etiketa nagusia",
    tipoPadre: "Nagusi mota",

    //FORM
    nombreEtiqueta: "Etiketa izena",

    //SUBPRODUCTOS
    agregarSubproducto: "Gehitu lehengaia",
    precioCompra: "Erosketa prezioa",
    escandallo: "Laginketa",
    subproductosCreados: "Sortutako lehengaiak",
    nuevaCategoria: "Kategoria berria",
    materiaPrima: "Lehengaia",
    materiasPrimas: "Lehengaiak",

    //FORM
    nuevoProveedor: "Hornitzaile berria",
    nombreSubproducto: "Lehengai berriaren Izena",
    codigoBarra: "Barra kodea",
    descripcion: "Deskribapena",
    tipoIva: "BEZ mota.",
    cuotaIVA: "BEZ kuota",
    ivaIncluido: "(BEZa barne)",
    descuentoCompra: "Erosketa deskontua",
    porcentaje: "(% Ehunekoa)",
    guardarEnAlmacen: "Biltegian gorde",
    stockMinimo: "Gutxieneko stocka",
    stockOptimo: "Stock optimoa",
    gastosPorProveedoresUnidos: "Gastuak hornitzaile elkartuen arabera",

    //INFORME SUBPRODUCTO
    referencia: "Erreferentzia",
    uds: "Unit.",
    iva: "BEZ",
    importe: "Zenbatekoa",
    dto: "Desk.",
    ttal: "Guztira",

    //PRODUCTOS
    producto: "Produktua",
    precioDeCoste: "Kostu prezioa",
    tarifa1: "Tarifa 1",
    tarifa2: "Tarifa 2",
    tarifa3: "Tarifa 3",
    tarifa4: "Tarifa 4",
    agregarProductos: "Gehitu produktua",
    noHayProductosEnEsteNegocio: "Ez dago produkturik negozio honetan",
    sinCategoria: "Kategoriarik gabe",

    //FORM
    nombreProducto: "Produktuaren izena",
    codigoDeBarra: "Barra kodea",
    colorBoton: "Botoiaren kolorea:",
    descuento: "Deskontua",
    precioCoste: "Kostu prezioa",
    opcionesAlSeleccionarElArticulo: "Produktua hautatzeko aukerak",
    numeroDeOpcionales: "Aukerako lehengaien kopurua",
    impresoraComandasTPV: "STko komandoen inprimagailua",
    impresoraComandasPDA: "PDA komandoen inprimagailua",
    copiaImpresoraComandasTPV: "ST komandoen inprimagailuaren kopia",
    copiaImpresoraComandasPDA: "PDA komandoen inprimagailuaren kopia",
    impresionPlano1: "1. planoko inprimagailua",
    impresionPlano2: "2. planoko inprimagailua",
    impresionPlano3: "3. planoko inprimagailua",
    impresionKDSTPV: "Bidali eskaera STtik",
    impresionKDSPDA: "Bidali eskaera PDAtik",
    pedirPrecio: "Eskatu prezioa",
    pedirPeso: "Pisua eskatu",
    pedirImporte: "Zenbatekoa eskatu",
    promocionable: "Sustagarria",
    mostrarPC: "PCan erakutsi",
    mostrarPDA: "PDAn erakutsi",
    noImprimir: "Ez inprimatu",
    numeroPlato: "Lehenetsitako plater kopurua",
    seleccionIngredientes: "Aktibatu osagaien hautaketa",
    introduzcaDescripcion: "Sartu deskribapena",
    introduzcaCodigoDeBarras: "Sartu barra kodea",
    introduzcaPrecioCoste: "Sartu kostu prezioa",
    opcion1: "Aukera 1",
    opcion2: "Aukera 2",
    opcion3: "Aukera 3",
    opcion4: "Aukera 4",
    opcion5: "Aukera 5",
    numOpcionales: "Aukerako lehengaien kopurua",

    //OPERARARIOS
    operarios: "Langileak",
    agregarOperario: "Langilea gehitu",
    apellido: "Abizena",
    nombreOperarios: "Langileen izena",
    pass: "Gakoa",
    salario: "Soldata",
    passTurn: "Txandako pasahitza",
    hombre: "Gizona",
    mujer: "Emakumea",
    replicarProducto: "Produktua beste negozio batzuetan kopiatzea",
    introduzcaEscandallo: "Sartu laginketa",
    introduzcaStockMinimo: "Sartu gutxieneko stocka",
    introduzcaStockOptimo: "Sartu stock optimoa",
    introduzcaPrecioCompra: "Sartu erosketa prezioa",
    introduzcaApellido: "Gehitu abizena",
    introduzcaPass: "Gehitu gakoa",
    introduzcaEmail: "Gehitu maila",
    introduzcaSalario: "Gehitu soldata",
    introduzcapassTurn: "Txandakako pasahitza gehitu",
    replicarOperario: "Langilea beste negozio batzueta kopiatzea",
    TPV: "TPV",
    precioMed: "Batezb. prezioa",
    porUnidad: "Unitateka",
    porImporte: "Zenbatekoa",
    contrasenya: "PDA pasahitza",
    repartidor: "Banatzailea",
    noMostrarEnVentas: "Ez erakutsi salmentetan",
    noHayOperariosEnEsteNegocio: "Ez dago langilerik negozio honetan",
    VerDetalles: "Ikusi Xehetasunak",
    accesoDenegado: "Sarrera Ukatua",

    //CLIENTES
    cliente: "Bezeroa",
    clientes: "Bezeroak",
    companyia: "Kanpaina",
    agregarCliente: "Bezeroa gehitu",
    nombreCliente: "Bezeroaren izena",
    saldo: "Saldoa",
    infoCliente: "Saldo txartelak erabiliz gero",
    tarifa: "Tarifa",
    descuentoImporte: "Zenbatekoaren deskontua",
    noHayClientesEnEsteNegocio: "Ez dago bezerorik negozio honetan",

    //IMPRESION
    impresionDeComandas: "Komandoak inprimatzea",
    copiaDeImpresionDeComandas: "Eskaerak inprimatzeko kopia",
    impresionPorPlana: "Planoko inprimaketa",
    monitorDeCocina: "Sukaldeko monitorea",

    //INFORMES
    ventas: "Salmentak",
    tarjetas: "Txartelak",
    cheque: "Txekea",
    cambio: "Aldaketa",
    recuento: "Kontaketa",
    descuadre: "Deskoadratzea",
    siguienteDia: "Hurrengo eguna",
    incidencias: "Gorabeherak",
    recaudado: "Bildutako dirua",
    noHayVentasEnEsteRangoDeFechas: "Ez dago salmentarik data tarte horretan",
    tickets: "Tiketak",
    factura: "Faktura",
    noHayFormasDePagoEnEsteRangoDeFecha: "Ez dago ordaintzeko modurik data-tarte horretan",
    desglose: "Banakapena",
    sinBase: "Oinarririk gabe",
    base: "Oinarria",
    impuesto: "Zerga",
    facturasEmitidas: "Faktura izendunak",
    mesa: "Mahaia",
    cifnif: "IFK/IFZ",
    cobro: "Kobrantza",
    noHayFacturasEmitidasEnEsteRangoDeFecha: "Ez dago data tarte horretan igorritako fakturarik",
    estadisticasAgencias: "Agentzien estatistikak",
    agencia: "Agentzia",
    comentario: "Iruzk.",
    noHayEstadisticasDeAgenciaEnEsteRangoDeFechas: "Ez dago agentzia estatistikarik data tarte horretan",
    desglosesImpuestos: "Kutxa ixteko zergak",
    desglosesImpuestosAgencia: "Zergak agentziaren arabera",
    noHayFormasDePagoEnEsteRangoDeFechas: "Ez dago ordaintzeko modurik data tarte horretan",
    cuentasAparcadas: "Kreditu kontuak",
    operacion: "Eragiketa",
    operario: "Langilea", //new
    noExisteDesgloseImpuestos: "Ez dago zergen banakapenik.", //new
    noHayCuentasAparcadasEnEsteRangoDeFechas: "Ez dago kreditu konturik data tarte horretan",
    noHayCuentasAnuladasEnEsteRangoDeFechas: "Ez dago data tarte horretan ezeztatutako konturik",
    cierreCaja: "Kutxa ixtea",
    fechaCierre: "Itxiera data",
    venta: "Salmenta",
    totalRecaudado: "Guztira jasotakoa",
    noHayCierresDeCajaEnEsteRangoDeFecha: "Ez dago kutxako itxierarik data tarte honetan",
    cierreCajaZ: "Kutxa itxiera Z",

    //MODAL
    n: "Zk.",
    apertura: "Irekiera",
    cierre: "Itxiera",
    totalVenta: "Salmentak guztira",
    efectivo: "Eskudirua",
    tarjetaCheques: "Txartelak+Txekeak",
    totalTeorico: "Teorikoa guztira",
    totalEnArqueo: "Guztira kontaketan",
    cambioSig: "Sig aldaketa",
    volver: "Itzuli",
    confirmacionImportacionHeader: "Inportazioaren berrespena",
    confirmacionImportacionText: "Ziur zaude inportatu nahi duzula?",
    cancelar: "Utzi",
    confirmar: "Berretsi",
    registros: "erregistroak",

    //OPERARIOS
    ventasPorOperarios: "Salmentak langileka",
    invitaciones: "Gonbidapenak",
    horas: "Orduak",
    sueldo: "Soldata",
    categorias: "Kategoriak",

    //CLIENTES
    ventasPorClientes: "Salmentak bezeroka",
    companya: "Enpresa",
    consumiciones: "Kontsumizioak",
    media: "Batazbestekoa",
    mediaSesion: "Saio erdia",

    //AGENCIAS
    noHayAgenciasEnEsteMomento: "Une honetan ez dago agentziarik",
    agencias: "Agentziak",
    nombreAgencia: "Agentziaren izena",
    comision: "Komisioa",
    replicarAgencias: "Erreplikatu agentzia",
    agregarAgencias: "Agentzia gehitu",

    //MODIFICADORES
    nombreModificador: "Aldatzailearen izena",
    grupos: "Taldeak",
    variacion: "Aldaketa",
    resta: "Kenketa",
    suma: "Batuketa",
    modificador: "Aldatzailea",
    modificadores: "Aldatzaileak",
    agregarModificador: "Aldatzailea gehitu",
    grupo: "Taldea",
    noHayModificadoresEnEsteNegocio: "Ez dago aldaketarik negozio honetan",
    almacen: "Biltegia",
    todos: "Denak",
    precioCompraConIva: "Erosketa prezioa BEZarekin",
    precioCompraSinIva: "Erosketa prezioa BEZik gabe",
    precioDescuentoSinIva: "Prezioa deskontuarekin BEZik gabe",
    codigoIdentificacion: "Identifikazio kodea",
    replicarModificador: "Erreplikatu aldatzailea",

    // SOPORTE ONLINE
    soporteOnline: "Online laguntza",
    soporteOnlineDetails: "Online laguntza - Xehetasunak",
    abierto: "Irekita",
    esperandoRespuesta: "Erantzunaren zain",
    respondido: "Erantzunda",
    cerrado: "Itxita",
    tecnico: "Teknikoa",
    comercial: "Komertziala",
    facturacion: "Fakturazioa",
    noTicketsEnNegocio: "Ez dago tiketik negozio honetan",
    responderTicket: "Erantzun tiketa",
    mensaje: "Mezua",
    cerrar: "Itxi",
    enviarTicket: "Tiketa bidali",
    nuevoTicket: "Tiket berria",
    asunto: "Gaia",
    estado: "Egoera",
    departamento: "Departamentua",
    visitas: "Bisitak",
    verTicket: "Ikusi tiketa",
    tarjeta: "Txartela",

    //FORMAS DE PAGO
    nueva: "Berria",
    replicarFormaDePago: "Kopiatu ordaintzeko modua",
    nombreFormaPago: "Ordaintzeko moduaren izena",
    formaDePago: "Ordaintzeko modua",
    formasDePago: "Ordaintzeko moduak",
    agregarFormaDePago: "Erantsi ordaintzeko modua",
    noHayFormasDePagoEnEsteNegocio: "Ez dago ordaintzeko modurik negozio honetan",
    nuevo: "Berria",

    //EDICIÓN MASIVA
    transferirProductosDeCategoria: "Transferitu kategoriako produak",
    tranferir: "Transferitu",
    impresionDeProductosDeCategorias: "Kategorietako produktuak inprimatzea",
    impresoraComanda: "Eskaera inprimagailua",
    impresoraComandaTpv: "STko eskaera inprimagailua",
    impresoraComandaPda: "PDA eskaera inprimagailua",
    copiaImpresionDeComanda: "Eskaerak inprimatzeko kopia",
    copiaImpresoraComandasTpv: "ST komandoen inprimagailuaren kopia",
    copiaImpresoraComandasPda: "PDA komandoen inprimagailuaren kopia",
    impresionPorPlano: "Planoko inprimaketa",
    enviarComandaDesdeTpv: "Bidali eskaera STtik",
    enviarComandaDesdePda: "Bidali eskaera PDAtik",
    respetarOtrasImpresiones: "¿Beste iritzi batzuk errespetatzea?",
    cambioDePrecioProductos: "Produktuen prezio aldaketa",
    opcion: "Aukera",
    tipoDeTarifa: "Tarifa mota",
    cambiarPrecio: "Prezioa aldatu",
    ajustes: "Doikuntzak",
    cambiarImpresionDeGrupo: "Aldatu talde inprimaketa",
    tranferirProductosDeUnaCategoriaAOtra: "Produktuak kategoria batetik bestera transferitzea",
    cambiarPreciosAProductos: "Aldatu prezioak produktuetara",

    //WIDGETS
    consumoPorHoras: "Ordukako salmentak",
    productosMasVendidos: "Produktu salduenak",
    ultimosTickets: "Azken tiketak",
    verTodos: "Denak ikusi",
    arqueoDeCaja: "Kutxako kontaketa",
    cobrado: "Kobratua",

    cajaCerrada: "Kaxa itxia",
    licenciaCaducada: "Lizentzia iraungita",
    cajonInteligente: "Kutxa adimenduna",
    moneda: "Dirua",
    nivelReciclador: "Birziklatze maila",
    totalReciclador: "Birziklapena guztira",
    nivelCasete: "Kasete maila",
    totalCasete: "Kasete guztira",
    totalMonedas: "Txanponak guztira",
    totalBilletes: "Billeteak guztira",
    totalEnDirectoPorNegocio: "Zuzeneko salmentak zuzeneko salmentak",
    enCuenta: "Kontuan",
    cajaOnline: "Online kutxak",
    planoDeMesas: "Mahaien planoa",
    planoDeTaquillas: "Armairuen planoa",
    nombrePlano: "Planoaren izena",
    mesas: "Mahaiak",
    taquillas: "Takilak",
    ocupacion: "Okupazioa",
    enPlano: "Planuan",
    desgloseTicket: "Tiketen banakapena",
    precioMedio: "Batez besteko prezioa",
    apuntado: "Apuntatua",
    anulado: "Ezeztatua",
    aparcado: "Kredituan",
    indicencias: "Gorabeherak",
    filtrarOperario: "Iragazi langilea",
    situacionActualDeLosNivelesDelCajonInteligente: "Kaxa adimenduneko mailen egungo egoera",
    verDetallesDeNiveles: "Ikusi mailen xehetasunak",
    noHayCajonInteligenteParaMostrar: "Ez dago erakusteko kaxa adimendunik",
    consulteConSuDistribuidor: "Galdetu zure banatzaileari",
    comparativaVentasAnteriores: "Aurreko salmenten konparazioa",
    graficaDeConsumoRespectoAHistoricoDeSesiones: "Kontsumoaren grafikoa saioen historiarekiko",
    graficaDeConsumoAgrupadaPorTramosHorarios: "Kontsumoaren grafikoa tarteka taldekatua",
    situacionActualDeOcupacionDeMesas: "Mahaien okupazioaren egungo egoera",
    situacionActualDeOcupacionDeTaquillas: "Armairuen egungo egoera",
    verPlanoCompleto: "Ikusi plano osoa",
    rankingDeLaSesionActual: "Uneko saioaren rankinga",
    ultimosMovimientosDeLaCajaPorOperario: "Kaxaren azken mugimenduak langileko",
    estadoActualDeLaCaja: "Kaxaren uneko egoera",
    turnosDeOperarios: "Langileen txandak",
    relacionDeHorasTrabajadasYVentasRealizadasPorOperario: "Lan egindako orduen eta langile bakoitzak egindako salmenten zerrenda",
    horarioInicio: "Hasiera ordua",
    horaFin: "Amaiera ordua",
    horasTrabajadas: "Lan egindako orduak",
    noHayTurnosDeOperarioParaMostrar: "Ez dago langileen txandarik erakusteko",
    propuestaDePedido: "Eskaera proposamena",
    pedidoAProveedor: "Eskaera hornitzaileari",
    atencionHayMovimientosDeAlmacenQueNoSeHanDescargadoEnElNegocio: "Adi, badira negozioan deskargatu ez diren biltegiko mugimenduak",
    seleccionarNegocio: "Hautatu negozioa",
    seleccionarProveedor: "Hautatu hornitzailea",
    generarPedidoEnBlanco: "Sortu eskaera zuria",
    generarPedido: "Sortu eskaera",
    propuestaDePedidoA: "Eskaera proposamena ",
    buscarMateriaPrimaEnElMismoProveedor: "Lehengaia hornitzaile berean bilatzea",
    precioIVAIncluido: "BEZ barne",
    ref: "Ref",
    nombre: "Izena",
    existencias: "Izakinak",
    pedido: "Eskaera",
    precioArticuloUnidad: "Artikulu / ale prezioa",
    precioPedido: "Eskaeraren prezioa",
    sinIVA: "BEZik gabe",
    porcentajeIVA: "% BEZ",
    precioIVA: "BEZ prezioa",
    porcentajeDto: "% Dtu",
    totalIVA: "BEZ guztira",
    observaciones: "Oharrak",
    noHaySubproductosEnEsteNegocioParaRealizarElPedido: "Ez dago azpiprodukturik eskaera egiteko",
    recuerdeQueParaQueAparezcanLosSubproductosDebenDeEstarAsociadosAUnProveedorYConfiguradosElStockMinimoYStockOptimo: "Gogoan izan azpiproduktuak agertu ahal izateko hornitzaile bati lotuta egon behar dutela gutxieneko stocka eta stock optimoa konfiguratu behar direla.",
    guardarPedido: "Eskaera gorde",
    totalIVAInc: "Guztira BEZa barne",
    pedidosAProveedor: "Eskaera hornitzaileari",
    fechaInicio: "Hasiera data",
    fechaFin: "Amaiera data",
    pedidosConvertidos: "Bihurtutako eskaerak",
    nuevoPedido: "Eskaera berria",
    enviarPedidos: "Bidali eskaerak",
    convertido: "Bihurtuta",
    convertirEnGasto: "Gastu bihurtu",
    modificar: "Aldatu",
    eliminar: "Ezabatu",
    descargarComoPDF: "Deskargatu PDF gisa",
    descargarComoPDFSinPrecios: "Deskargatu PDF gisa preziorik gabe",
    descargarComoExcel: "Excel gisa deskargatu",
    descargarComoExcelSinPrecios: "Deskargatu excel gisa preziorik gabe",
    enviarPorCorreo: "Postaz bidali",
    eliminarListaCorreo: "Ezabatu posta zerrenda",
    anyadirListaCorreo: "Gehitu posta zerrenda",
    noHayPedidosAEsteProveedorEnEsteRangoDeFecha: "Data tarte horretan ez dago eskaerarik hornitzaile honi",
    enviarPedido: "Bidali eskaera",
    enviarPedidoA: "Bidali eskaera honi:",
    formato: "Formatua",
    PDF: "PDF",
    excel: "Excel",
    conPrecios: "Preziokin",
    sinPrecios: "Preziorik gabe",
    convertirPedido: "Bihurtu eskaera",
    tipoDeDocumento: "Dokumentu mota",
    albaran: "Albarana",
    generarEntradaEnAlmacenAlVerificar: "Sortu sarrera biltegian egiaztatzean",
    gastosDeCasas: "Etxeetako gastuak",
    gastosPorCasa: "Etxeko gastuak",
    noHayGastosPorCasasEnEsteRangoDeFechas: "Ez dago etxeko gasturik data-tarte horretan",
    ventasDeCategorias: "Kategorien salmentak",
    ventasCategoriaDe: "Salmentak ",
    volverAGeneral: "Itzuli orokorrera",
    ventasDeProductos: "Produktuen salmentak",
    filtrarPorTPV: "Iragazi STaren arabera",
    filtrarTPV: "Iragazi TPV",
    turnosDe: "Txandak ",
    horaInicio: "Hasiera ordua",
    enActivo: "Jardunean",
    ventasDeProductosDe: "Produktuen salmentak ",
    ventasOperarios: "Langileen salmentak",
    costesDeProductos: "Produktuen kostuak",
    totalImportesVentas: "Salmenten zenbatekoak guztira",
    totalCoste: "Kostua guztira",
    costes: "Kostuak",
    costeUd: "Unitateko kostua",
    coste: "Kostua",
    porcentajeCosto: "Kostuaren%",
    varCostoMed: "Ald. Kostu ertaina",
    listaDeInvitaciones: "Gonbidapenen zerrenda",
    valor: "Balorea",
    volverALaLista: "Zerrendara itzuli",
    ventasDeProductosGlobal: "Produktu orokorren salmentak",
    porUnidades: "Unitateka",
    gastosPorEtiquetas: "Gastuak etiketen arabera",
    desgloseDeGastos: "Gastuen banakapena",
    referencias: "Erreferentziak",
    concepto: "Kontzeptua",
    gastosDeProveedores: "Hornitzaileen gastuak",
    sinProveedor: "Hornitzailerik gabe",
    sinCasas: "Etxerik gabe",
    cierreDeCaja: "Kaxa ixtea",
    primerTicket: "Lehen tiketa",
    ultimoTicket: "Azken tiketa",
    cheques: "Txekeak",
    cambioSigDia: "Sig. aldaketa eguna",
    ventasPorAgencias: "Agentzien araberako salmentak",
    ventasPorFormasDePago: "Salmentak ordaintzeko moduaren arabera",
    exportarComoHTML: "Esportatu HTML gisa",
    pendiente: "Egiteke",
    gasto: "Gastua",
    desgloseDeImpuestos: "Zergen banakapena",
    desgloseDelTicket: "Tiketaren banakapena",
    cuentasAnuladas: "Baliogabetutako kontuak",
    buscarPorHoras: "Bilatu orduka",
    mostrarVentasAcumuladasPorDia:"Erakutsi eguneko salmenta metatuak", 
    seleccionaUnTpv:"Bere xehetasunak ikusteko TPV bat hautatu behar duzu",
    deshabilitarCheckboxVentasAcumuladasPorDia:"Xehetasunak ikusteko, desgaitu 'Erakutsi eguneko salmenta metatuak' kontrol-laukia.",
    graficas: "Grafikoak",
    dias: "Egunak",
    semanas: "Asteak",
    meses: "Hilabeteak",
    ventasPorComensales: "Jankideen salmentak",
    numeroDeComensales: "Mahaikideen kopurua",
    precioMedioPorComensal: "Precio medio por comensal",
    ventasPorRangosHorarios: "Salmentak ordu-tarteen arabera",
    ops: "Ops",
    comensales: "Mahaikideak",
    detalleDeOperaciones: "Eragiketen xehetasunak",
    operaciones: "Eragiketak",
    operacionMedia: "Batez besteko eragiketa",
    detalleDeComensales: "Mahaikideen xehetasunak",
    comensalMedio: "Mahaikide medioa",
    noHayVentasEnLosRangosDeFechasDefinidos: "Ez dago salmentarik definitutako data tarteetan",
    transferencia: "Transferentzia",
    domiciliacion: "Helbideratzea",
    fechaGasto: "Gastuaren data",
    generarEntradaDeAlmacenAlVerificar: "Sortu biltegi sarrera egiaztatzean",
    listaDeMateriaPrima: "Lehengai zerrenda",
    preciosIVAIncluido: "Prezioak, BEZa barne",
    precioSinIVA: "Prezioak BEZarik gabe",
    precioIVAInc: "Prezioa, BEZa barne",
    IVA: "BEZ",
    totalBase: "Oinarria guztira",
    totalDocumento: "Dokumentua guztira",
    seleccioneUnaCasa: "Hautatu etxe bat",
    anyadirNuevoSubproducto: "Gehitu azpiproduktu berria",
    gestionDeGastos: "Gastuen kudeaketa",
    deCaja: "Kutxakoak",
    fueraDeCaja: "Kutxatik kanpo",
    contabilizado: "Kontabilizatua",
    si: "Bai",
    no: "Ez",
    grafica: "Grafikoa",
    lista: "Zerrenda",
    avanzado: "Aurreratua",
    noHayVentasDeProductosEnEsteRangoDeFechas: " Ez dago produktu salmentarik data-tarte horretan",
    historicoDeProductos: "Produktuen historikoa",
    volverA: "Itzuli hona:",
    general: "Orokorra",
    historialAlmacen: "Biltegiaren historiala",
    listadoDeExistencia: "Izakinen zerrenda",
    listadoDeAlmacen: "Biltegi-zerrenda",
    listadoHastaStockOptimo: "Stock optimoa lortu arteko zerrenda",
    pedidoHastaStockOptimo: "Stock optimoraino eskatzea",
    listadoExistenciaBajoMinimo: "Gutxieneko bajaren zerrenda",
    exportarValoracion: "Esportatu balorazioa",
    importeDto: "Deskontuaren zenbatekoa",
    detalleDelSubproducto: "Azpiproduktuaren xehetasunak",
    nombreNegocio: "Negozioaren izena",
    noHaySubproductosConElMismoNombreEnTusOtrosNegocios: "Ez dago izen bereko azpiprodukturik zure beste negozioetan",
    detalleAlmacen: "Biltegiaren xehetasunak",
    entrada: "Sarrera",
    inventario: "Inbentarioa",
    salida: "Irteera",
    valorDto: "Deskontuaren balioa",
    noHayDatosEnEsteMovimientoDeAlmacen: "Ez dago daturik biltegiko mugimendu horretan",
    historial: "Historikoa",
    noHayMovimientoEnEstaMateriaPrima: "Ez dago mugimendurik lehengai horretan",
    dia: "Eguna",
    historialDeAlmacen: "Biltegiaren historiala",
    inventarios: "Inbentarioak",
    entradas: "Sarrerak",
    salidas: "Irteerak",
    completado: "Osatua",
    verificado: "Egiaztatuta",
    descargado: "Deskargatuta",
    diaActual: "Uneko eguna",
    movimientos: "Mugimenduak",
    enEsteRangoDeFechas: "data tarte honetan",
    rangosHorarios: "Ordu tarteak",
    nuevoRangoHorario: "Ordu tarte berria",
    verUnInformeDeRangosHorarios: "Ikusi ordu tarteen txostena",
    noHayRangosHorariosEnEsteNegocio: "Ez dago ordu tarterik negozio honetan",
    nombreRangosHorarios: "Ordu tarteen izena",
    vistaMosaico: "Mosaiko ikuspegia",
    vistaLista: "Zerrendaren ikuspegia",
    ordenarProductos: "Produktuak ordenatzea",
    BAJA: "BAJA",
    frontalDeVenta: "Aurreko salmenta",
    agregarGasto: "Gehitu gastua",
    entrAlmac: "Sarrer. Bilt.",
    contab: "Kontab.",
    tranferencia: "Tranferentzia",
    verificar: "Egiaztatu",
    entradaAlmacen: "Biltegiko sarrera",
    preciosIVAInluido: "Prezioak BEZa barne",
    estaEntradaNoContieneNingunSubproducto: "Sarrera honek ez du azpiprodukturik",
    cajasOnline: "On line kutxak",
    minimo: "Minimoa",
    optimo: "Optimoa",
    posicionGlobal: "Kokapen globala",
    empresa: "Enpresa",
    ventasSinIVA: "BEZik gabeko salmentak",
    neto: "Garbia",
    fechaDeCumpleanyos: "Urtebetetze data",
    recargoEquivalencia: "Baliokidetasun errekargua",
    anyadirMateriaPrima: "Gehitu lehengaia",
    partesT1: "T1 zatiak",
    partesT2: "T2 zatiak",
    partesT3: "T3 zatiak",
    partesT4: "T4 zatiak",
    costeDto: "Deskontuaren kostua",
    agregarMateriasPrimas: "Gehitu lehengaiak",
    unidadesEnOtroNegocios: "Unitateak beste negozio batzuetan",
    historialMateriaPrima: "Lehengaiaren historiala",
    verDetalles: "Ikusi xehetasunak",
    borrarRangoHorario: "Ezabatu ordu tartea",
    detallesDeLaEntradaEnAlmacen: "Biltegiko sarreraren xehetasunak",
    desgloseHorasTrabajadas: "Lan egindako orduen banakapena",
    verProductosVendidos: "Ikusi saldutako produktuak",
    verTicketsDelProducto: "Ikusi produktuaren tiketak",
    verTicketsDeEsasInvitaciones: "Ikusi gonbidapen horien tiketak",
    verTicketsDeEsaAgencia: "Ikusi agentzia horren tiketak",
    gastosPorMateriasPrimas: "Lehengaien gastuak",
    alDarUnProductoDeBajaDesapareceEnElTPVParaSuVentaPeroSigueApareciendoEnLosInformesDeVenta: "Produktu bat baja ematean, STan desagertu egiten da saltzeko, baina salmenta-txostenetan agertzen jarraitzen du",
    cuandoUnProductoEsDeTipoDescuentoSuPrecioSeDescuentaDelTotalDeLaCuenta: "Produktu bat deskontu motakoa denean, haren prezioa kontu osotik deskontatuko da",
    alActivarEstaOpcionApareceLosIngredientesDelProductoParaSeleccionarlo: "Aukera hau aktibatzean, produktuaren osagaiak agertzen dira hautatzeko",
    alActivarEstaOpcionPuedeSeleccionarElPrecioDelProductoAlMarcarlo: "Aukera hau aktibatzean, produktuaren prezioa hauta dezakezu markatzean",
    alActivarEstaOpcionPuedeSeleccionarElPesoDelProductoAlMarcarlo: "Aukera hau aktibatzean, produktuaren pisua hauta dezakezu markatzean",
    alActivarEstaOpcionPuedeSeleccionarElImporteDelProductoAlMarcarlo: "Aukera hau aktibatzean, produktuaren zenbatekoa hauta dezakezu markatzean",
    alActivarEstaOpcionElProductoNoApareceraEnNumierTPV: "Aukera hau aktibatzean, produktua ez da agertuko Numier TPVn",
    alActivarEstaOpcionElProductoNoApareceraEnLaPda: "Aukera hau aktibatzean, produktua ez da Numier PDAn agertuko",
    alActivarEstaOpcionElProductoNoSeImprimiraEnElPendienteDeCobroNiEnLaFacturaSimplificada: "Aukera hau aktibatzean, produktua ez da kobratuko ez faktura erraztuan inprimatuko.",
    guardarMateriaPrima: "Gorde lehengaia",
    copiarMateriaPrima: "Kopiatu lehengaia",
    seleccioneQueTipoDeMateriasPrimasQuiereCopiar: "Hautatu zer lehengai mota kopiatu nahi duzun",
    seleccioneAQueCategoriaQuiereCopiarLasMateriasPrimas: "Hautatu zein kategoriatan kopiatu nahi dituzun lehengaiak",
    copiaMateriaPrima: "Lehengaiaren kopia",
    notas: "Oharrak",
    pedidos: "Eskariak",
    atencionLaMediaSinContarLosDiasConVentas: "Adi: batez bestekoa, salmenta egunak kontuan hartu gabe, 0 €da: ",
    verDesgloseDeImpuestos: "Ikus zergen banakapena",
    verDetallesDetTicket: "Ikusi tiketaren xehetasunak",
    facturasNominativas: "Faktura izendunak",
    verDetallesDeGasto: "Ikusi gastu xehetasunak",
    desgloseDeGastosPorEtiquetasHijas: "Gastuen banakapena alaben etiketen arabera",
    procedencia: "Jatorria",
    suLicenciaDeNumierOnlineEstaAPuntoDeCaducar: "Iraungitzear dago Numier Online lizentzia",
    cajasOnlineTickets: "Online kutxak Tiketak",
    cajasOnlineDetalles: "Online kutxak Xehetasunak",
    cajasOnlinePlano: "Lineako kaxak Planoa",
    cajasOnlineProductos: "Online kutxak Produktuak",
    transferir: "Transferitu",
    herramientas: "Tresnak",
    ver: "Ikusi",
    detallesDeLaentradaEnAlmacen: "Biltegiko sarreraren xehetasunak",
    ups:"Ups",
    laFechaDeInicioNoPuedeSerPosteriorALaDeFin:"Hasiera data ezin da amaierakoa baino geroagokoa izan",
    seleccioneUnProveedor:"Hautatu hornitzaile bat",
    detallesDelPedido:"Eskaeraren xehetasunak",
    correoEnviadoCorrectamente:"Mezua behar bezala bidali da",
    atencion:"Adi",
    debeIntroducirUnEmailParaEnviarElPedido:"Mezu elektroniko bat sartu behar duzu eskaera bidaltzeko",
    detalles:"Xehetasunak",
    gastoVerificadoCorrectamente:"Gastua behar bezala egiaztatu da",
    estasSeguroDeEliminarElPedido:"Ziur zaude eskaera ezabatu nahi duzula?",
    estaOperacionNoSePuedeDeshacer:"Eragiketa hori ezin da desegin",
    siEliminarPedido:"Bai, eskaera ezabatu",
    pedidoEliminadoCorrectamente:"Eskaera behar bezala ezabatu da",
    laReferenciaEsObligatoria:"Erreferentzia nahitaezkoa da",
    seleccioneLosNegociosParaHacerelPedido:"Aukeratu negozioak eskaera egiteko",
    noHayProveedoresEnEsteNegocio:"Ez dago hornitzailerik negozio honetan",
    cuentasRectificadas:"Kontu zuzenduak", //new   
    noHayCuentasRectificadasEnEsteRangoDeFechas: "Ez dago data tarte horretan zuzendutako konturik", //new
    pedidosProveedor: "Hornitz. eskaerak",
    
    gestionDePersonal: "Langileen kudeaketa",
    configuracionCarta: "Kartaren konfigurazioa",
    importacionExcels:"Excelak inportatzea",
    carta: "Gutun digitala",
    camaras: "Kamerak",
    perfil: "Profila",
    cerrarSesion: "Itxi saioa",
    desarrolladoPorNexodoDigitalSL: "Nexodo Digital S.L.k garatua",
    totalValores: "Balioak guztira",
    totalValoresDto: "Deskontuaren balioak guztira",
    totalValoresRecuento: "Guztira Zenbaketa Balioak",
    ultimoInventario: "Azken inbentarioa",
    filtrarEntreInventarios: "Inbentarioen artean iragazi",
    ultInventario: "Azken inbentarioa",
    primerInventario: "Lehengo inbentarioa",
    marcaDosInventariosParaVerLosDetallesEntreEllos: "Bi inbentario markatu, bien arteko xehetasunak ikusteko",
    salir: "Irten",
    anadirMovimientoAlmacen: "Gehitu biltegiko mugimendua",
    nuevoInventario: "Inbentario berria",
    tienesUnInventarioSinTerminarElDia: "Inbentarioa amaitu gabe duzu",
    pulseElBotonRealizarInventarioPara: "Sakatu Inbentarioa egin botoia",
    volverARealizarlo: "berriro egin",
    siDeseas: "Nahi baduzu",
    comenzarElInventarioDeNuevo: "inbentario berria hasi",
    comaMarqueLaCasillaEliminarDatosDeInventarioActual: ", markatu `Ezabatu uneko inbentarioko datuak laukia'",
    eliminarDatosDelInventarioActual: "Ezabatu uneko inbentarioko datuak",
    realizarInventario: "Inbentarioa egin",
    accesoDenegado: "Sarbidea ukatuta",
    soloPuedeComprobar2InventariosAlMismoTiempo: "Bi inbentario bakarrik egiazta ditzakezu aldi berean",
    cargando: "Kargatzen...",
    configuracionAlmacen: "Biltegiaren konfigurazioa",
    actualizada: "eguneratua",
    correctamente: "behar bezala",
    noSeAdmitenCamposEnBlanco: "Ez da eremu zuririk onartzen",
    todas: "Denak",
    categoriaClientes: "Bezero kategoria",
    seleccionaCompania: "Hautatu konpainia",
    agregarCategoriaDeClientes: "Gehitu bezero kategoria",
    categoriaPadre: "Kategoria nagusia",
    elCampoNombreFiscalEsObligatorio: "Izen fiskala eremua nahitaezkoa da",
    elCampoCifNifEsObligatorio: "IFZ eremua nahitaezkoa da",
    datosActualizadosCorrectamente: "Datuak behar bezala eguneratu dira",
    elCampoNombreEsRequerido: "Izena eremua bete behar duzu",
    creada: "sortua",
    rangoHorario: "Ordu tartea",
    soloPuedeCrearUnMaximoDeXRangosHorarios: "Gehienez ere 8 ordu tarte sor ditzakezu",
    deAcuerdo: "Ados",
    rangoHorario: "Ordu tartea ",
    eliminado: "ezabatuta",
    deseaEliminarEsteRangoHorario: "Ordu tarte hori ezabatu nahi duzu?",
    siBorrarRangoHorario: "Bai, ordu tartea ezabatu",
    ordenarProductosAlfabeticamente: "Produktuak alfabetikoki ordenatzea",
    ordenarMateriasPrimasAlfabeticamente: "Lehengaiak alfabetikoki ordenatzea",
    asignarImpresorasSeleccionadasEnBlanco: "Esleitu zuriz hautatutako inprimagailuak",
    aplicarCambios: "Aplikatu aldaketak",
    ordenarAlfabeticamenteProductos: "Produktuak alfabetikoki ordenatzea",
    ordenar: "Ordenatu",
    ordenarAlfabeticamenteSubproductos: "Azpiproduktuak alfabetikoki ordenatzea",
    seleccioneElTipo: "Hautatu mota",
    impresionDeProductosEfectuadaCorrectamente: "Produktuak behar bezala inprimatu dira",
    tienesQueSeleccionarUnaCategoria: "Kategoria bat hautatu behar duzu",
    ningunaSeleccionada: "Bat ere ez da hautatu",
    transferenciaDeProductosEfectuadaCorrectamente: 'Produktuak behar bezala transferitu dira',
    relleneLosCamposObligatorios: "Bete nahitaezko eremuak",
    vistaFrontalTpv: "STaren aurreko ikuspegia",
    editarPrecios: "Editatu prezioak",
    cancelarEdicion: "Utzi edizioa",
    guardarOrden: "Gorde ordena",
    bajaConBrackets: "[BAJA]",
    seleccionaUnaCategoria:"Hautatu kategoria bat...",
    cambiarImpresorasAProductos: "Aldatu inprimagailuak produktuetara",
    igualar: "Berdindu",
    sumar: "Gehitu",
    restar: "Kendu",
    multiplicar: "Biderkatu",
    todasLasTarifas: "Tarifa guztiak",
    productosEditadosCorrectamente: "Behar bezala editatutako produktuak",
    ordenActualizadoCorrectamente: 'Behar bezala editatutako produktuak',
    componentesDeVenta: "Salmenta osagaiak",
    delNegocioAClientes: "negoziotik bezeroetara",
    clasificacionDe: "Sailkapena",
    productosPorFamilia: "produktuak familiako",
    elementosQue: "Elementu hauek:",
    varianALosProductos: "produktuetara aldatzen dira",
    paraLaComanda: "eskaera egiteko",
    componentesComprados: "Erositako osagaiak",
    aProveedoresQueComponenProductos: "produktuak osatzen dituzten hornitzaileei",
    empresas: "Enpresak",
    proveedorasDeMateriasPrimasYServicios: "lehengaien eta/edo zerbitzuen hornitzaileak",
    alNegocio: "negozioan",
    fabricantesDeMateriasPrimas: "lehengai fabrikatzaileak",
    aProveedores: "hornitzaileei",
    categoriasQueClasifican: "Kategoriak",
    materiasPrimasYProveedores: "lehengaiak eta hornitzaileak",
    personalCon: "Langileak",
    acceso: "sarbidea",
    alSistema: "sistemara",
    baseDeDatosDe: "Datu basea",
    consumidores: "kontsumitzaileak",
    enElNegocio: "negozioan",
    clasificacionDeLa: "ren sailkapena",
    deLasVentas: "salmentak",
    metodosDeCobro: "Kobratzeko metodoak",
    enElFrontalDeVenta: "salmentako frontalean",
    intervaloDeHorasParaConsultarVentas: "Salmentak kontsultatzeko ordu tartea",
    configurarAlmacén: "Biltegia konfiguratu",
    relacionDeMateriasPrimasParaLaConfiguracionDelAlmacen: "Biltegia konfiguratzeko lehengaien zerrenda",
    herramientasGenerales: "Tresna orokorrak",
    edicionMasiva: "Edizio masiboa",
    categoriasCarta: "Gutunaren kategoriak",
    categoriaCarta: "gutunaren kategoria",
    orden: "Ordena",
    editada: "editatuta",
    anadirCategoria: "Gehitu kategoria",
    esteNegocioNoTieneAccesoAEsteModulo: "Negozio honek ez du modulu honetarako sarbiderik",
    paraMasInformacionContacteConSu: "Informazio gehiago nahi izanez gero, jarri harremanetan",
    distribuidor: "banatzailea",
    formasDePagoCarta: "Gutuna ordaintzeko moduak",
    formaDePagoCarta: "gutuna ordaintzeko modua",
    informacionCarta: "Kartaren informazioa",
    datosDelNegocio: "Negozioaren datuak",
    nombreMostrado: "Erakutsitako izena",
    telefonoWhatsapp: "WhatsApp telefonoa",
    datosPedidos: "Eskaeren datuak",
    tiempoMedioDePreparacionRecogidaMin: "Jasotzeko prestatzeko batez besteko denbora (min)",
    tiempoMedioDePreparacionDomicilioMin: "Etxean prestatzeko batez besteko denbora (min)",
    gastosDeEnvio: "Bidalketa gastuak",
    pedidoMinimo: "Gutxieneko eskaera",
    interfaz: "Interfazea",
    textoEntrega: "Entrega testua",
    textoPresentacion: "Aurkezpenaren testua",
    textoFormasDePago: "Ordaintzeko moduen testua",
    textoHorarios: "Ordutegien testua",
    datosGuardadosCorrectamente: "Datuak behar bezala gorde dira",
    materiasPrimasCarta: "Aukerako lehengaiak",
    materiaPrimaCarta: "Kartako lehengaia",
    referenciaMateriasPrimasTpv: "TPV lehengaien erreferentzia",
    nombreDeLaMateriaPrimaEnElTpv: "Lehengaiaren izena STan",
    disponible: "Eskuragarri",
    replicarMateriaPrima: "Lehengaia erreplikatu",
    replicarMateriasPrimas: "Lehengaiak errepikatzea",
    nombreTpv: "TPVaren izena",
    noDisponible: "Ez dago erabilgarri",
    replicarTodasLasMateriasPrimas: "Lehengai guztiak erreplikatzea",
    estasSeguroDeReplicarTodasLasMateriasPrimasALosNegociosSeleccionados: 'Ziur zaude hautatutako negozioei lehengai guztiak aplikatuko dizkiezula?',
    estaAccionNoSePuedeDeshacer: 'Ekintza hau ezin da desegin!',
    siReplicar: 'Bai, erreplicatu',
    productosCarta: 'Kartako produktuak',
    productoCarta: 'Karta produktua',
    referenciaProductoTpv: 'TPV produktuaren erreferentzia',
    nombreDelProductoEnElTpv: 'Produktuaren izena TPVan',
    seleccionaCategoria: "Kategoria hautatu",
    seleccionaTipo: "Mota hautatu",
    nIngredientesSinCosto: "Kosturik gabeko osagai kopurua",
    maximoExtras: "Estrak gehienez",
    alergenos: "Alergenoak",
    nombreTarifa1: "1. tarifaren izena",
    precioTarifa1: "1. tarifaren prezioa",
    nombreTarifa2: "2. tarifaren izena",
    precioTarifa2: "2. tarifaren prezioa",
    nombreTarifa3: "3. tarifaren izena",
    precioTarifa3: "3. tarifaren prezioa",
    nombreTarifa4: "4. tarifaren izena",
    precioTarifa4: "4. tarifaren prezioa",
    imagen: "Irudia",
    copiarMateriasPrimas: "Lehengaiak kopiatzea",
    basico: "Oinarrizkoa",
    buscarNombreDeLaMateriaPrima: "Bilatu lehengaiaren izena",
    seleccionaTipoPunto: "Hautatu mota",
    bases: "Oinarriak",
    opcionales: "Aukerakoak",
    extras: "Gehigarriak",
    cereales: "Zerealak",
    crustaceos: "Krustazeoak",
    huevos: "Arrautzak",
    pescado: "Arraina",
    cacahuetes: "Kakahueteak",
    soja: "Soja",
    leche: "Esnea",
    frutosDeCascara: "Fruitu oskoldunak",
    apio: "Apioa",
    mostaza: "Ziapea",
    granosDeSesamo: "Sesamo aleak",
    dioxidoDeAzufre: "Sufre dioxidoa",
    altramuces: "Altramuzeak",
    moluscos: "Moluskuak",
    cartaASecas: "Karta",
    extra: "Extra",
    opcional: "Aukerakoa",
    estreProcesoBorraraLasMateriasPrimasActualesEnLasCategoriasSeleeccionadasDeLosTiposElegidos: 'Prozesu honek hautatutako kategorietan aukeratutako lehengaiak ezabatuko ditu.',
    aceptarProceso: "Onartu prozesua",
    necesitasMarcarAlMenosUnTipoYUnaCategoria: "Gutxienez mota eta kategoria bat markatu behar duzu",
    materiaPrimaCopiadaCorrectamente: "Lehengaia behar bezala kopiatu da",
    editado: "editatuta",
    agregada: "agregatua",
    relacion: "Zerrenda",
    noPuedeHaberDosMateriasPrimasConElMismoTipo: "Ezin dira mota bereko bi lehengai egon.",
    estasSeguroDeBorrarLaMateriaPrima: "Ziur zaude lehengaia ezabatu nahi duzula?",
    siDeseoBorrarlo: "Bai, ezabatu egin nahi dut",
    seleccionaUnaCarta: "Hautatu karta bat",
    replicarProductos: "Produktuak erreplikatu",
    verCarta: "Karta ikusi",
    verPedido: "Eskaera ikusi",
    verQR: "QRa ikusi",
    nombreEnTpv: "TPVaren izena",
    cartaYPedido: "Karta eta eskaera",
    replicarTodosLosProductos: "Produktu guztiak erreplikatu",
    editarImagen: "Irudia editatu",
    esteNegocioNoContieneNingunaCarta: "Negozio honek ez du kartarik",
    estasSeguroDeReplicarTodosLosProductosALosNegociosSeleccionados: 'Ziur zaude produktu guztiak hautatutako negozioetan erreplikatuko dituzula?',
    sustanciasQue: "Substantzia hauek:",
    componenALosProductos: "produktuak osatzen dituzte",
    informacionAcercaDel: "Informazioa",
    negocioMinuscula: "negozioa",
    actualizarPedidos: "Eguneratu eskaerak",
    pendienteDeConfirmacion: "Berresteko",
    confirmados: "Berretsiak",
    enPreparacion: "Prestatzen",
    finalizados: "Amaituta",
    recogida: "Bilketa",
    domicilio: "Helbidea",
    noHayPedidosPendientesDeConfirmacion: "Ez dago baieztatu gabeko eskaerarik",
    noHayPedidosConfirmados: "Ez dago eskaera berretsirik",
    noHayPedidosEnPreparacion: "Ez dago eskaerarik prestatzen",
    noHayPedidosTerminados: "Ez dago bukatutako eskaerarik",
    siBorrarPedido: "Bai, ezabatu eskaera",
    estasSeguroDeSuspenderElServicioEnMesas: "Ziur zaude mahaietako zerbitzua bertan behera utzi nahi duzula?",
    siSuspendeElServicioEnMesasNoEntraranMasPedidosEnMesaHastaActivarloDeNuevo: "Mahaietako zerbitzua eteten badu, ez dira eskaera gehiago sartuko berriro aktibatu arte",
    siSuspenderElServicioEnMesa: "Bai, bertan behera utzi zerbitzua mahaian",
    estasSeguroDeActivarElServicioEnMesas: "Ziur zaude zerbitzua mahaietan aktibatu nahi duzula?",
    siActivaElServicioDeMesasVolveranAEntrarPedidosDeMesa: "Mahaien zerbitzua aktibatzen baduzu, berriro sartuko dira mahaiko eskaerak",
    siActivarElServicioEnMesa: "Bai, aktibatu zerbitzua mahaian",
    estasSeguroDeSuspenderElServicio: "Ziur zaude zerbitzua bertan behera utzi nahi duzula?",
    siSuspendeElServicioNoEntraranMasPedidosHastaActivarloDeNuevo: "Zerbitzua eteten baduzu, ez dira eskaera gehiago sartuko berriro aktibatu arte",
    siSuspenderElServicio: "Bai, zerbitzua eten",
    estasSeguroDeActivarElServicio: "Ziur zaude zerbitzua aktibatu nahi duzula?",
    siActivaElServicioVolveranAEntrarPedidos: "Zerbitzua aktibatzen baduzu, berriro sartuko dira eskaerak",
    siActivarElServicio: "Bai, aktibatu zerbitzua",
    pedidoAceptadoCorrectamente: "Eskaera behar bezala onartu da",
    pedidoEnPreparacion: "Eskaera prestatzen",
    pedidoFinalizado: "Eskaera amaituta",
    pedidoArchivado: "Eskaera artxibatua",
    servicioActualizadoCorrectamente: "Zerbitzua behar bezala eguneratu da",
    estasSeguroDeEditarLaObservacion: "Ziur zaude behaketa editatu nahi duzula?",
    siEditarObservacion: "Bai, editatu behaketa",
    mesasActivadas: "AKTIBATU DIREN MAHAIAK⠀",
    mesasDesactivadas: "DESAKTIBATUTAKO MAHAIAK⠀",
    crearNuevoProveedor: "Sortu hornitzaile berria",
    crearMateriaPrima: "Sortu lehengaia",
    eliminarMateriaPrima: "Lehengaia ezabatu",
    sinCasaAsignada: "Etxerik esleitu gabe",
    buscarPorRefONombreDeLaMateriaPrima: "Bilatu erreferentziaren arabera edo Lehengaiaren izena",
    seleccioneEtiqueta: "Etiketa hautatu...",
    unidadesStockMinimo: "Gutxieneko stock-unitateak",
    partesStockMinimo: "Gutxieneko stockaren parteak",
    anadirProveedor: "Gehitu hornitzailea",
    amarillo: "horia",
    cajas: "Kutxak",
    botellas: "Botilak",
    barriles: "Upelak",
    palets: "Paletak",
    bolsas: "Poltsak",
    litros: "Litroak",
    rollos: "Biribilkiak",
    visualizar: "Bistaratu",
    sinCasa: "Etxerik gabe",
    elProveedorEsObligatorio: "Hornitzailea nahitaezkoa da",
    laFechaEsObligatoria: "Data nahitaezkoa da",
    hayUnaMateriaPrimaSinUnidades: "Unitaterik gabeko lehengaia dago",
    hayUnaMateriaPrimaSinPrecio: "Preziorik gabeko lehengaia dago",
    guardandoGasto: "Gastua gordetzen...",
    actualizado: "eguneratua",
    creado: "sortua",
    laLongitudDelNombreNoPuedeSerMayorDe: "Izenaren luzera ezin da izan ",
    relleneTodosLosDatosMarcadosConAsteriscoAntesDeEnviar: "Bete * ikurra duten datu guztiak bidali aurretik",
    seleccionaProveedor: "Hautatu hornitzailea...",
    filtrarPorFecha: "Iragazi dataren arabera",
    convertirAlbaranes: "Bihurtu albaranak",
    cancelarConversion: "Bertan behera utzi bihurketa",
    convertir: "Bihurtu",
    convertirAlbaranEnFactura: "Bihurtu albarana faktura",
    refFactura: "Faktura erref.",
    albaranesDeLaFactura: "Fakturaren albaranak",
    finalizada: "bukatuta",
    conversion: "Bihurketa",
    error: "Errorea",
    estaSeguroDeVerificarEsteGasto: "Ziur zaude gastu hori egiaztatu nahi duzula?",
    siVerficarGasto: "Bai, gastua egiaztatu",
    estasSeguroDeEliminarElGasto: "Ziur zaude gastua ezabatu nahi duzula?",
    siEliminarGasto: "Bai, ezabatu gastua",
    contabilizadoCambiadoCorrectamente: "Kontabilizatutakoa behar bezala aldatu da",
    gastoEliminadoCorrectamente: "Gastua behar bezala ezabatu da",
    hacerInventario: "Inbentarioa egin",
    seleccionarTodas: "Denak hautatu",
    inventarioRealizadoCorrectamente: "Inbentarioa behar bezala egin da",
    traspaso: "Pasatu",
    negocioDeDestino: "Helburuko negozioa",
    referenciaNecesaria: "Beharrezko erreferentzia",
    elMovimientoDeAlmacenTieneQueTenerAsignadoUnProductoOProductos: "Biltegiko mugimenduak produktu bat edo batzuk esleituta izan behar ditu",
    realizado: "egina",
    buscarSinPuntos: "Bilatu",
    enviarInventario: "Bidali inbentarioa",
    volverAlAlmacen: "Biltegira itzuli",
    inventarioCompletado: "Inbentarioa osatuta",
    inventarioNoEncontrado: "Inbentarioa ez da aurkitu",
    cargandoInventario: "Inbentarioa kargatzen",
    importacion: "Inportazioa",
    importar: "Inportatu",
    tienesQueSeleccionarUnArchivoDeImportacion: "Inportazio fitxategi bat hautatu behar duzu",
    importandoVentasDelNegocio: "Negozioko salmentak inportatzen...",
    nuevosProductos: "Produktu berriak",
    seHanCreadoLosSiguientesProductos: "Produktu hauek sortu dira:",
    importandoMovimientosDeAlmacen: "Biltegiko mugimenduak inportatzen...",
    importandoDatos: "Datuak inportatzen...",
    tienesQueSeleccionarUnArchivoDeImportacion: "Inportazio fitxategi bat hautatu behar duzu",
    seleccionaCasa: "Hautatu etxea...",
    desgloseDeVentasPorProductos: "Salmenten banakapena produktuka",
    noTienesPermisoParaVisualizarEsteInforme: "Ez duzu baimenik txosten hau bistaratzeko",
    historicoVentasPorCliente: "Salmenten historia bezeroko",
    buscarPorNombreDelCliente: "Bilatu bezeroaren izenaren arabera",
    importeSinDto: "Deskonturik gabeko zenbatekoa",
    nTickets: "Tiket kopurua",
    seleccioneUnClienteValido: "Hautatu baliozko bezero bat",
    seleccioneUnNegocioParaVerLosTickets: "Hautatu negozio bat tiketak ikusteko",
    ventasDeCategoriasPorClientes: "Kategorien salmentak bezeroka",
    desgloseDeVentasDeLaCategoria: "Kategoriaren salmenten banakapena",
    verImporteEnCategoriasHijas: "Ikus zenbatekoa alaben kategorietan",
    gestionDePedidos: "Eskaeren kudeaketa",
    cargandoGastos: "Gastuak kargatzen...",
    tiempoMedioCocina: "Sukaldearen batez besteko denbora",
    nComandas: "Komando-kop.",
    eliminada: "ezabatu",
    tiempoMedio: "Batez besteko denbora",
    noHayComandasEnviadasAlKdsEnEsteRangoDeFechas: "Ez dago kd-ra bidalitako komandoik data tarte honetan",
    tiempoMedioProducto: "Produktuaren batez besteko denbora",
    nProductos: "Produktu kopurua",
    informePersonalizado: "Txosten pertsonalizatua",
    nombreDelDispositivo: "Gailuaren izena",
    dispositivo: "Gailua",
    registrosHorarios: "Ordu erregistroak",
    marshallEjecutadoCorrectamente: "Marshall ondo exekutatu da",
    mes: "Hilabetea",
    seleccionaUnaSemana: "Hautatu astebete",
    seleccioneUnaFechaValida: "Hautatu baliozko data bat",
    noMayuscula: "EZ",
    siMayuscula: "BAI",
    editarObservacion: "Editatu behaketa",
    anadirObservacion: "Gehitu oharra",
    editarHoraInicioYHoraFin: "Editatu hasiera ordua eta amaiera ordua",
    editarHorario: "Editatu ordutegia",
    editarHorarioDeTurno: "Editatu txandako ordutegia",
    observacion: "Behaketa",
    turnosOperarios: "Langileen txandak",
    compartirEnlaceTurnos: "Partekatu txandak esteka batean",
    enlaceGeneradoExito:"Esteka behar bezala sortu da",
    enlaceCopiadoAlPortapapeles:"Esteka arbelean kopiatu da",
    enlaceExternoTurnosTitle: "Hitzordua kontsultatzeko kanpoko esteka",
    enlaceExternoTurnosLabel: "Esteka honen bidez operadoreen txandak egiaztatu ditzakezu. 24 orduren buruan iraungiko da.",
    errorComunicacionBackend: "Zerbitzariarekin komunikazio-errorea.",
    enlaceExternoTurnosCaducadoTitle: "Esteka iraungi da",
    enlaceExternoTurnosCaducadoLabel: "Operadoreen txandak egiaztatzeko, jarri harremanetan negozioaren administratzailearekin esteka berri bat sortzeko.",
    ventasDeProductosMinusculas: "produktuen salmentak",
    pedidosGuionPasarelaDePago: "Eskaerak - Ordainketa-pasabidea",
    numPedidos: "Eskaera-kopurua",
    costoPorPedido: "Eskaeraren kostua",
    totalComisiones: "Komisioak, guztira",
    totalSinComisiones: "Guztira, komisiorik gabe",
    errorEnLaPeticion: "Errorea eskaeran",
    rentabilidad: "Errentagarritasuna",
    buscarPorNombreDelRepartidor: "bilaketa banatzailearen izenaren arabera",
    verDesgloseDeTarifas: "Ikusi tarifen banakapena",
    ventasPorMeses: "Salmentak hilabeteka",
    ventasHoras: "Ordukako salmentak",
    tarifasDelProducto: "Produktuaren tarifak",
    cantidad: "Kantitatea",
    fechaDesde: "Noiztik data",
    fechaHasta: "Noiz arte",
    seleccionaProcedencia: "Hautatu jatorria...",
    verDesgloseFacturas: "Ikusi fakturen banakapena",
    verDesgloseMateriasPrimas: "Ikusi lehengaien xehetasunak",
    seleccionaUnaEtiqueta: "Hautatu etiketa bat",
    buscarPorNombreDeLaMateriaPrima: "Bilatu lehengaiaren izenaren arabera",
    ventasDeMateriasPrimas: "Lehengaien salmenta",
    seleccionaTpv: "TPVa hautatu...",
    deVentas: "salmenten",
    totalComision: "Komisioa, guztira",
    totalSinComision: "Komisiorik gabeko guztizkoa",
    desgloseFacturas: "Fakturen banakapena",
    facturasDelProveedor: "Hornitzailearen fakturak",
    retiradas: "Erretiratuak",
    buscarTicket: "Bilatu tiketa...",
    baseMayusculas: "BASEA",
    numServ: "Zk. Zerb.",
    ticketMed: "Gutxieneko tiketa",
    necesitasElegirUnTpvParaPoderVerLosDetallesDeEste: "TPVa bat aukeratu behar duzu honen xehetasunak ikusteko",
    ventasMinusculas: "salmentak",
    totales: "Guztira",
    noTienesNingunRangoDeFechaCreadoDeseasCrearUnRangoDeFecha: "Ez duzu data tarterik sortu. Data-tarte bat sortu nahi duzu?",
    siCrearUnRangoHorario: "Bai, ordu tarte bat sortu",
    detalleDe: "Honen xehetasuna:",
    cierresDeCaja: "kaxa itxiturak",
    ventasNegocioPorZonaHoraria: "Negozio salmentak ordu-eremuka",
    porZonaHoraria: " ordu eremuka",
    detalleDeVentasSegun:"Salmenten xehetasunak",
    comensalesMinuscula: " mahaikideak",
    desgloseDe: "Banakapena",
    ticketsCobrados: "kobratutako tiketak",
    segunTipoDeIVA: "BEZ motaren arabera",
    facturasEmitidas: "Igorritako fakturak",
    aClientes: " bezeroei",
    desgloseDeVentasSegun: "Salmenten banakapena ",
    formasDePagoMinusculas: "ordaintzeko moduak",
    agenciasMinusculas: "agentziak",
    cuentasACredito: "kreditu kontuak",
    sumatorioDe: "Batukaria: ",
    impuestos: "zergak",
    porFechas: " dataz",
    cuentasAnuladasMinusculas: "baliogabetutako kontuak",
    delNegocio: " negozioaren",
    cuentasRectificadas: "Kontu zuzenduak",
    cuentasRectificadasMinusculas: "kontu zuzenduak",
    retiradasMinusculas: "erretiratuak",
    ventaDeProductosPorNegocio: "Produktuen salmentak negozioko",
    rankingDe: "Rankinga",
    costeDeProductos: "Produktuen kostua",
    margenDeCostes: "Kostu marjina",
    segunVentasPorRangoDeFecha: "salmenten arabera, data tartearen arabera",
    historicoDeProducto: "Produktuaren historikoa",
    rankingAgrupadoDe: "Sailkapena:",
    enTodosLosNegocios: "negozio guztietan",
    ventasDeCategoriasPorNegocio: "Kategorien salmentak negozioko",
    agrupacionDe: "Taldekatzea",
    ventasDeCategoriasMinusculas: "kategorien salmenta minuskulak",
    deProductos: "produktuena",
    invitacionesMinusculas: "gonbidapenak",
    ventasPorMateriasPrimas: "Lehengaien salmentak",
    ventasDeMateriasPrimasMinusculas:"lehengaien salmenta",
    comprasDeMateriasPrimas: "lehengaiak erostea",
    porRangoDeFecha: "data tartearen arabera",
    comprasAProveedores: "erosketak hornitzaileei",
    comprasAUnProveedor: "erosketak hornitzaile bati",
    porRangoDeFechaEn: "data tartearen arabera",
    todosLosNegocios: "negozio guztiak",
    comprasAgrupadasPorEtiquetas: "erosketak etiketen arabera taldekatuta",
    comprasAFabricantes: "fabrikatzaileen erosketak",
    comprasAUnFabricante: "erosketak fabrikatzaile bati",
    ranking: "Rankinga",
    detallesDe: "Honen xehetasunak:",
    turnos: "txandak",
    ventasPorClientesPlural: "Salmentak bezeroka",
    deVentasPorClientes: "salmentak bezeroka",
    consultaDeVentasPorCliente: "Salmenten kontsulta bezeroka",
    historico: "Historikoa",
    deVentasPorClientes: "salmentak bezeroko",
    numierPedidos: "Numier Pedidos",
    informeDePasarelaDePago: "Ordainketa pasabidearen txostena",
    desgloseDiarioDeLosPagosATraves: "Bidezko ordainketen eguneroko banakapena",
    pasarelaDePagoStripe: "Ordainketa pasabidea (Stripe)",
    clicParaMasInformacion: "Klik informazio gehiago nahi baduzu",
    cantidadMinusculas: "Kantitatea",
    totalMinusculas: "guztira",
    tarjetaYCheques: "Txartelak eta Txekeak",
    seleccionaOperario: "Langilea hautatu...",
    necesitasSeleccionarUnProveedorParaPoderHacerUnPedido: "Hornitzaile bat hautatu behar duzu eskaera egin ahal izateko",
    estePedidoNoEsValido: "Eskaera hau ez da baliozkoa",
    quieresRestablecerElPedido: "Eskaera berrezarri nahi duzu?",
    siRestablecerPedido: "Bai, berrezarri eskaera",
    datosPersonales: "Datu pertsonalak",
    datosDeAcceso: "Sarbide datuak",
    contrasenaAntigua: "Pasahitz zaharra",
    contrasenaNueva: "Pasahitz berria",
    confirmarContrasena: "Berretsi pasahitza",
    quieresDarDeAltaUnUsuario: "Erabiltzaile bati alta eman nahi diozu?",
    quieresDarDeBajaUnUsuario: "Erabiltzaile bati baja eman nahi diozu?",
    licencias: "Lizentziak",
    fechaCaducidad: "Iraungitze data",
    ilimitado: "MUGAGABEA",
    lasContrasenasNoCoinciden: "Pasahitzak ez datoz bat",
    seleccionaUsuario: "Hautatu erabiltzailea...",
    usuario: "Erabiltzailea",
    negocios: "Negozioak",
    balance: "Balantzea",
    teHaParecidoUtilEsteArticulo: "Erabilgarria iruditu zaizu artikulu hau?",
    graciasPorTuOpinion: "Mila esker zure iritziagatik",
    asignarTurno: "Txanda esleitu",
    vacaciones: "Oporrak",
    descargarPDF: "PDFa deskargatu",
    enviarHorario: "Ordutegia bidali",
    incidenciasEnElMes: "gorabeherak hilabetean",
    diasDeVacacionesEnElMes: "opor egunak hilabetean",
    diasDeVacacionesEnElAno: "urteko opor egunak",
    nuevoTurno: "Txanda berria",
    clonarTurno: "Klonatu txanda",
    nombreDelTurno: "Txandaren izena",
    diasDeLaSemana: "Asteko egunak",
    editarTurno: "Txanda editatu",
    borrarTurno: "Txanda ezabatu",
    evento: "Ekitaldia",
    nombreEvento: "Gertaeraren izena",
    hayUnaIncidenciaEnEsteTurno: "Gorabehera bat dago txanda honetan",
    fechaInicioTurno: "Txandaren hasiera data",
    fechaFinTurno: "Txandaren amaiera data",
    numHorasTurno: "Txandako ordu kopurua",
    fechaInicioTrabajada: "Lan egindako hasiera data",
    fechaFinTrabajada: "Lan egindako amaiera data",
    numHorasTrabajadas: "Lan egindako ordu kopurua",
    noIniciado: "Hasi gabe",
    noFinalizado: "Bukatu gabe",
    fechaInicioVacaciones: "Oporren hasiera data",
    fechaFinVacaciones: "Oporren amaiera data",
    turnoHorario: "Ordutegia",
    nombreTurno: "Txandaren izena",
    campoRequerido: "Eskatutako eremua",
    introduzcaLosDiasDeLaSemana: "Sartu asteko egunak",
    crearTurnoHorarioDeOperario: "Sortu langilearen ordutegia",
    introduzcaLosOperarios: "Sartu langileak",
    laboral: "Lan kontratuduna",
    vacacional: "Oporrak",
    seleccionaTurno: "Aukeratu txanda...",
    seleccionaLosNegociosALosQueQuiereClonarElTurno: "Hautatu zein negoziotara igo nahi duzun txanda",
    seleccionaLaFechaEnLaQueDeseasCopiarLosHorarios: "Hautatu zein egunetan kopiatu nahi dituzun ordutegiak",
    seleccioneUnaSemana:"Hautatu aste bat",
    lunes: "Astelehena",
    martes: "Asteartea",
    miercoles: "Asteazkena",
    jueves: "Osteguna",
    viernes: "Ostirala",
    sabado: "Larunbata",
    domingo: "Igandea",
    laFechaSeleccionadaNoEsValida: "Hautatutako data ez da baliozkoa",
    turnoClonadoCorrectamente: "Txanda ondo klonatuta",
    correoEnviadoCorrectamente: "Mezua behar bezala bidali da",
    estasSeguroDeBorrarElTurnoSeleccionado: "Ziur zaude hautatutako txanda ezabatu nahi duzula?",
    siBorrarTurno: "Bai, ezabatu txanda",
    necesitasCrearAlgunTurnoParaPoderCrearCuadrantes: "Txandaren bat sortu behar duzu koadranteak sortzeko",
    estasSeguroDeEditarElTurno: "Ziur zaude txanda editatu nahi duzula?",
    siEditarTurno: "Bai, txanda editatu",
    hoy: "Gaur",
    turno: "Txanda",
    turnoBorradoCorrectamente: "Txanda behar bezala ezabatu da",
    informacion: "Informazioa",
    elDiaNoCorrespondeConLaConfiguracionDelTurnoElegido: "Eguna ez dator bat hautatutako txandaren konfigurazioarekin",
    turnoCopiadoCorrectamente: "Txanda behar bezala kopiatu da",
    turnoDeOperarioAgregadoCorrectamente: "Langilearen txanda behar bezala gehitu da",
    turnoDeOperarioEliminadoCorrectamente: "Langilearen txanda behar bezala ezabatu da",
    turnoDeOperarioEditadoCorrectamente: "Langilearen txanda behar bezala editatu da",
    tecnicoConsultasTecnicasIncidencias: "Teknikaria (kontsulta teknikoak, gorabeherak...)",
    comercialActivacionDeProductosInformacionServicios: "Komertziala (produktuak aktibatzea, informazioa, zerbitzuak...)",
    administracionFacturacionReclamaciones: "Administrazioa (fakturazioa, erreklamazioak...)",
    elAsuntoEsObligatorio: "Gaia nahitaezkoa da",
    elMensajeEsObligatorio: "Mezua nahitaezkoa da",
    soporteOnlineEnviadoCorrectamente: "On-line laguntza behar bezala bidali da",
    todosLosNegociosMayusculas: "Negozio guztiak",
    recordarMisDatos: "Gogoratu nire datuak",
    paraCualquierIncidenciaOMasInformacionPuedePonerseEnContactoConNosotros: "Edozein gorabehera edo informazio gehiago nahi izanez gero, jarri gurekin harremanetan",
    iniciarSesion: "Hasi saioa",
    haOlvidadoSuContrasena: "Pasahitza ahaztu duzu?",
    haHabidoUnErrorAlConectarPruebeDeNuevo: "Errorea gertatu da konektatzean. Saiatu berriro",
    elEmailNoPuedeEstarEnBlanco: "Helbide elektronikoa ezin da hutsik egon",
    elEmailNoEsValido: "Helbide elektronikoa ez da baliozkoa",
    laContrasenaNoPuedeEstarEnBlanco: "Pasahitza ezin da hutsik egon",
    estaPaginaNoSeEncuentraEnElSistema: "Orrialde hau ez dago sisteman",
    volverAlInicio: "Itzuli hasierara",
    obtenerContrasena: "Pasahitza lortu",
    disculpeLasMolestiasEstamosDeMantenimiento: "Barkatu eragozpenak, mantentze-lanetan ari gara",
    vuelvaAIntentarloMasTarde: "Saiatu berriro geroago",
    acepto: "Onartzen dut",
    categoriasDeClientes: "Bezero kategoriak",
    categoriaDeCliente: "Bezero kategoria",
    nombreCategoria: "Kategoria izena",
    noSeleccionada: "Hautatu gabea",
    cobradoMayusculas: "KOBRATUA",
    envioProgramadoPara: "Bidalketa programatua",
    eliminarPedido: "Ezabatu eskaera",
    aceptarPedido: "Onartu eskaera",
    pedidoConfirmado: "Eskaera berretsia",
    archivarPedido: "Eskaera artxibatzea",
    detallesPedido: "Eskaeraren xehetasunak",
    nota: "Oharra",
    precioUd: "Unit. prezioa",
    gratis: "DOAN",
    guardarYAceptarPedido: "Eskaera gorde eta onartu",
    seleccionaGrupo: "Hautatu taldea...",
    todosMayusculas: "DENAK",
    nombreOperario: "Langilearen izena",
    apellidos: "Abizenak",
    claveAcceso: "Pasahitza",
    codigoDeTurnos: "Txanda kodea",
    claveAccesoPDA: "PDA pasahitza",
    seleccionaIVA: "BEZa hautatu",
    calcularCostoAPartirDeMateriasPrimas: "Lehengaiak erabiliz kostua kalkulatzea",
    seleccionaImpresoraDeComandasTPV: "TPV komandoen inprimagailua hautatzen du",
    seleccionaImpresoraDeComandasPDA: "Hautatu PDA komando-inprimagailua",
    buscarMateriaPrima: "Bilatu lehengaia",
    nuevaMateriaPrima: "Lehengai berria",
    ordenarSubproductos: "Azpiproduktuak ordenatu",
    seleccionaEtiqueta: "Hautatu etiketa...",
    clonarProducto: "Klonatu produktua",
    clonarProductoCarta: "Klonatu produktua",
    buscarSinPuntos: "Bilatu",
    noPuedeHaberDosMateriasPrimasConElMismoTipo: 'Ezin dira mota bereko bi lehengai egon',
    sinProveedores: "Hornitzailerik gabe",
    agregadas: "agregatuak",
    modificadas: "aldatuak",
    materiaPrimaEliminadaCorrectamente: "Lehengaia ezabatu egin da eta zuzendu egin da",
    asociacion: "elkartea",
    materiaPrimaOrdenadaCorrectamente: "Lehengaia behar bezala ordenatuta",
    productosCopiadosCorrectamente: "Behar bezala kopiatutako produktuak",
    responder: "Erantzun",
    cliente: "Bezeroa",
    administracion: "Administrazioa",
    soporteTecnico: "Laguntza teknikoa",
    horaInicioMayusculas: "Hasiera ordua",
    horaFinal: "Amaiera ordua",
    personaDeContacto: "Harremanetarako pertsona",
    motivoVisita: "Bisitaren arrazoia",
    servicioBajoMantenimiento: "Mantentze lanetarako zerbitzua",
    desplazamiento: "Joan-etorriak",
    ticketEnviadoCorrectamente: "Tiketa behar bezala bidali da",
    precioCompraConDescuento: "Erosketa prezioa deskontuarekin",
    introduzcaLasPartesDelStockMinimo: "Sartu gutxieneko stockaren parteak",
    actualizarStockMinimoYOptimo: "Eguneratu gutxieneko stocka eta stock optimoa",
    subproductoDeVerdad: "Azpiproduktua",
    entregado: "Entregatua",
    retirada: "Kentzea",
    subtotal: "Guztizko partziala",
    pagosACuenta: "Konturako ordainketak",
    horaDeApertura: "Irekitzeko ordua",
    horaInicio: "Hasiera ordua",

    condicionesDeNumierOnline: "Numier Online baldintzak",
    descripcionDelServicio: "Descripcion del Servicio",
    terminosIntroduccionParte1: "NEXODO DIGITAL S.L.k eskaintzen duen Numier-en hodeiko zerbitzua. (hemendik aurrera, NEXODO), negozioei buruzko informazio eguneratua online eskuratzeko aukera ematen die bezeroei.",
    terminosIntroduccionParte2: "Horretarako, Numierren saltokietako aplikazioek Interneten bidez bidaliko dituzte egindako salmenten xehetasunak eta bezeroentzat interesgarria izan daitekeen bestelako informazioa.",
    terminosIntroduccionParte3: "Zerbitzu honetarako sarbidea https://www.numier.com/clientes web orriaren bidez egingo da, eta han zure saltokietatik bidalitako informazioa kontsultatu ahal izango duzu.",
    terminosIntroduccionParte4: "NEXODOk eskubidea du zerbitzua edozein unetan hobetzeko, aldatzeko edo baliogabetzeko.",
    politicaDePrivacidad: "Pribatutasun politika",
    privacidadParte1: "1. NEXODOk pribatutasun-adierazpen hau egin du bere pribatutasuna babesteko asmo sendoa adierazteko. NEXODOk eskatzen dizu arretaz irakurtzeko pribatutasun-politika hau zerbitzu hau erabili aurretik, horrek esan nahi baitu NEXODOk zure datu pertsonalak bildu eta prozesatu behar dituela politika honen arabera. NEXODOk pribatutasun-politika edozein unetan aldatzeko eskubidea du. Kasu horretan, NEXODO zurekin harremanetan jartzeko konpromisoa hartzen du, eragiten dioten aldaketen berri emateko.",
    privacidadParte2: "2. NEXODOk pribatutasun-aukerak errespetatzen ditu. Informaziorik emanez gero, politika horren arabera jokatuko da.",
    privacidadParte3: "3. NEXODOk zuhurtziaz jokatzea gomendatzen dizu, operadoreei edo gunearen jabeei informazioa ematerakoan. Kontuan izan behar da sarbide publikoko lekuetan, hala nola txat-aretoetan, informazio pertsonala emateak esan nahi duela Interneten sartzen den edonork bere informazioa izan dezakeela. Eremu publiko horietan besteek ikustea nahi ez duen informaziorik ez sartzea gomendatzen dizugu.",
    privacidadParte4: "4. NUMIER ONLINen erregistratzea erabakitzen baduzu, baliteke datu pertsonalak eman behar izatea. Garrantzitsua da informazioa erregistro-datan behar bezala erregistratzea. Zure informazio pertsonala erregistroa egin ondoren aldatzen bada, berehala aldatu edo eguneratu beharko duzu. Hala egin ezean, baliteke NEXODOren zerbitzurik edo informaziorik ez jasotzea.",
    privacidadParte5: "5. NEXODOk zure informazio pertsonala erabil dezake gune honetan hobekuntzak egiteko.",
    privacidadParte6: "6. NEXODOk datu horiek biltzen ditu, bere zerbitzuak eta produktuak hobetzeko informazioa lortzeko. Eta baliteke zuk eman diguzun informazioa posta elektronikoz edo postaz interesgarriak izan daitezkeen eskaintzak bidaltzeko erabiltzea.",
    privacidadParte7: "7. Mezu horietako harpidetza bertan behera uzteko, NEXODOrekin harremanetan jarri beharko duzu, zure erabakiaren berri emateko. Bestela, NEXODO(e)k erabiltzailearen informazioa gordeko du harpidetza baliogabetzen den arte edo indarrean dagoen araudian deskribatzen den edozein epe amaitu arte.",
    privacidadParte8: "8. NEXODOK ez dizkio bere datuak hirugarren bati jakinaraziko bere baimenik gabe, legeak hala eskatzen duela uste ez badugu behintzat.",
    privacidadParte9: "9. Gure datu-basean dauden zure harpidetzako datu guztiak ezeztatzeko aukera duzu. Horretarako, enpresarekin harremanetan jarri eta eskaera egin beharko du.",
    privacidadParte10:"10. NEXODOk neurriak hartu ditu informazioa hasieran sartu zuen erabiltzailearentzat bakarrik egongo dela eskuragarri bermatzeko. ",
    privacidadParte11: "11. Pasahitza sartu ondoren soilik sar daiteke informaziora.",
    privacidadParte12: "12. Gune honek NEXODOrekin loturarik ez duten beste gune batzuetarako estekak izan ditzake. Gune horiek pribatutasun-politika propioak dituzte, eta NEXODO ez da horien erantzule egiten. Lotutako gune horietara sartzeko, haien erantzukizuna besterik ez da.",
    privacidadParte13: "13. NEXODOk bere erabiltzaileei buruzko informazioaren segurtasuna bermatzen du, hauetan izan ezik:",
    privacidadParte13dos: "- NEXODOk zure baimena badu.",
    privacidadParte13tres: "- NEXODOri informazio hori emateko eskatzen bazaio, legezko aginduz, errekerimendu judizialez edo beste prozedura juridiko baten bidez.",
    privacidadParte13cuatro: "- Datu horien berri ematea beharrezkoa bada NEXODOren eskubideak eta jabetza babesteko.",
    privacidadParte13cinco: "- Zure datuen berri ematea beharrezkoa bada gure bezeroen zerbitzuak eta produktuak hobetzeko, zu barne.",
    privacidadParte14: "14. NEXODOk bere informazioa zerbitzari seguru eta enkriptatu batean behar bezala mantentzea bermatzen du, baimendutako hirugarrenak bakarrik sar daitezkeelarik. ",

    cartaDigital: "Karta digitala",
    horarios: "Ordua",
    zonas: "Eremuak",
    modificarHorariosDeLaCarta: "Aldatu gutunaren ordutegiak",
    modificarZonasDeLaCarta: "Aldatu gutuneko eremuak",
    diaDeLaSemana: "Asteko eguna",
    esteNegocioNoTieneCarta: "Negozio honek ez du kartarik",
    tipoDeEnvio: "Bidalketa mota",
    nuevoHorario: "Ordutegi berria",
    elCampoDiaDeLaSemanaEsRequerido: "Asteko eguna eremua bete behar duzu",
    borrarHorario: "Ezabatu ordutegia",
    laHoraInicioNoPuedeSerMayorQueLaHoraFin: "Hasiera ordua ezin da amaiera ordua baino handiagoa izan",
    noHayHorariosEnEsteNegocio: "Ez dago ordutegirik negozio honetan",
    deseaEliminarEsteHorario: "Ordutegi hau ezabatu nahi duzu?",
    siBorrarHorario: "Bai, ezabatu ordutegia",
    seleccioneDiaDeLaSemana: "Aukeratu asteko eguna",
    seleccioneTipoDeEnvio: "Bidalketa motaren hautapena",

    //NUEVO
    importacionSage: "Sage inportazioa",
    ejercicio: "Ekitaldia",
    codigoEmpresa: "Enpresaren kodea",
    asiento: "Idazpena",
    cargoAbono: "Abonuaren kargua",
    codigoCuenta: "Kontu kodea",
    fechaAsiento: "Idazpenaren data",
    comentario: "Iruzkina",
    importeAsiento: "Idazpenaren zenbatekoa",
    numeroPeriodo: "Aldiaren zenbakia",
    delegacion: "Eskuordetzea",
    canal: "Kanala",
    ejercicioFactura: "Fakturaren ekitaldia",
    serie: "Seriea",
    factura: "Faktura",
    suFacturaNo: "Zure faktura zenb.",
    fechaFactura: "Fakturaren data",
    importeFactura: "Fakturaren zenbatekoa",
    tipoFactura: "Faktura mota",
    codigoCuentaFactura: "Faktura-kontuaren kodea",
    codigoRetencion: "Atxikipen kodea",
    baseRetencion: "Atxikipen oinarria",
    porRetencion: "Atxikipenagatik",
    importeRetención: "Atxikipenaren zenbatekoa",
    baselva1: "1. baselba",
    porlva1: "Porva 1",
    cuotaIva1: "BEZaren kuota 1",
    porRecargoEquivalencia1: "1 baliokidetasun errekarguagatik",
    recargoEquivalencia1: "1 baliokidetasun errekargua",
    codigoTransaccion1: "1. transakzio-kodea",
    descargarComoTxt: "Deskargatu .txt gisa",

    noHayAsientosContablesEnEsteTpvEnEsteRangoDeFecha: "Ez dago data-tarte hori duen kontularitzako idazpenik TPV honetan",
    cargandoAsientosContables: "Kontabilitate idazpenak kargatzen",
    fechaDeAperturaDeCaja: "Kaxa irekitzeko data",
    fechaDeCierreDeCaja: "Kaxaren itxiera data",
    descargarVentas: "Deskargatu salmentak",
    descargarGastos: "Gastuak deskargatu",
    noHasCerradoEstaCaja: "Ez duzu itxi kaxa hau",
    numeroDeCierres: "Itxitura kopurua",
    introduzcaElUltimoNumeroDeAsientoContableQueTieneEnSAGE: "Sartu SAGEn duzun kontabilitateko idazpenaren azken zenbakia",
    porFavorRelleneElAsientoContable: "Mesedez, bete kontabilitate-idazpena",
    descargar: "Deskargatu",
    elAsientoContableDebeSerUnNumero: "Kontabilitate idazpenak zenbaki bat izan behar du",
    elAsientoContableNoPuedeSerMayorA10Digitos: "Kontabilitateko idazpena ezin da digitu baino handiagoa izan",
    TengaEnCuentaQueUtilizaremosLosSiguientesNumerosAEsteParaCompletarLosDatos: "Kontuan izan zenbaki hauek erabiliko ditugula datuak osatzeko",
    noExistenVentasEsteDia: "Egun honetan ez dago salmentarik",
    noExistenGastosEsteDia: "Egun honetan ez dago gasturik",
    enSage: "SAGEn",
    proyecto: "Proiektua",
    codigoEmpresaHelp: "Gogoratu enpresaren datua enpresa bereko negozio guztien artean partekatzen dela.",
    cuentasDelTpvSeleccionado: "Hautatutako TPVaren kontuak",
    nuevaCuenta: "Kontu berria",
    nombreDeCuenta: "Kontuaren izena",
    codigoCuentaMinuscula: "Kontuaren kodea",
    tipoDeCuenta: "Kontu mota",
    noHayCuentasCreadasConElTpvSeleccionado: "Ez dago TPVa hautatuta duen konturik sortuta",
    crearNuevaCuenta: "Kontu berria sortu",
    codigoDeLaCuenta: "Kontuaren kodea",
    codigoDeLaSubcuenta: "Azpikontuaren kodea",
    configuracionCuentasIva: "BEZ kontuen konfigurazioa",
    configuracionCuentasEspeciales: "Kontu berezien konfigurazioa",
    cuenta: "Kontua",
    subcuenta: "Azpikontua",
    editarCuenta: "Editatu kontua",
    tipo: "Mota",
    sage200: "SAGE 200",
    losCamposNombreCodigoDeCuentaYCodigoDeSubcuentaDebenEstarRellenos: "Izena, kontu-kodea eta azpikontu-kodea eremuek beteta egon behar dute",
    estaSeguroDeQueDeseaEliminarEstaCuenta: "Ziur zaude kontu hau ezabatu nahi duzula?",
    siBorrarCuenta: "Bai, ezabatu kontua",
    cuentaEditadaCorrectamente: "Kontua behar bezala editatu da",
    cuentaCreadaCorrectamente: "Kontua behar bezala sortu da",
    configuracionSAGE: "Sage konfigurazioa",
    sinCuentaAsociada: "Lotutako konturik gabe",
    loSientoSuNegocioNoTieneContratadoSAGE: "Sentitzen dugu, zure negozioak ez du SAGE kontratatua",
    paraMasInformacionContacteConComerciales: "Informazio gehiago nahi izanez gero, jarri harremanetan komertzialekin",
    laLongitudMaximaDeLasSubCuentas: "Kontaketaren luzera maximoa 12 karakterekoa izan behar da",
    codigo: "Kodea",
    crearNuevoCodigoCuenta: "Sortu kontu kode berria",
    editarNuevoCodigoCuenta: "Editatu kontu kode berria",
    seleccioneUnaFormaDePagoParaElGasto: "Hautatu ordaintzeko modu bat gasturako",
    hasSeleccionadoAlbaranesConDiferentesFormasDePagoPorFavorSeleccioneUna: "Hainbat ordainketa modu dituen albaranak hautatu dituzu; mesedez, hautatu bat",
    seleccioneUnaFormaDePago: "Hautatu ordaintzeko modu bat",
    zonasActualizadasCorrectamente: "Behar bezala eguneratutako eremuak",
    zonaCreadaCorrectamente: "Eremua behar bezala sortu da",
    zonaEditadaCorrectamente: "Eremua behar bezala editatu da",
    guardarCambios: "Gorde aldaketak",
    laZonaNoPuedeTenerElNombreEnBlanco: "Eremuak ezin du izena hutsik izan",
    zonasDeReparto: "Banaketa eremuak",
    editarZona: "Editatu eremua",
    color: "Kolorea",
    costeDeReparto: "Banaketa-kostua",
    pedidoMinimo: "Gutxieneko eskaera",
    crearNuevaZona: "Sortu eremu berria",
    estasSeguroDeQueQuieresEliminarLaZona: "Ziur zaude eremua ezabatu nahi duzula?",
    estaZonaDejaraDeEstarDisponibleInmediatamenteYNoSePodranHacerPedidos: "Eremu hau ez da berehala erabilgarri egongo eta ez da eskaerarik egingo bertatik.",
    siEliminarZona: "Bai, ezabatu eremua",
    zonaEliminadaCorrectamente: "Eremua behar bezala ezabatu da",
    ventasExportadas: "Esportatutako salmentak",
    gastosExportados: "Esportatutako gastuak",
    todosLosCierresDeEsteDiaHanSidoExportados: "Egun horretako itxiera guztiak esportatu egin dira",
    faltanVentasPorExportarEsteDia: "Egun horretan esportatzeko salmentak falta dira",
    todosLosGastosDeEsteDiaHanSidoExportados: "Egun horretako gastu guztiak esportatu egin dira",
    faltanGastosPorExportarEsteDia: "Egun horretan esportatzeko gastuak falta dira",
    /*this.$i18n.t("productos"))*/

    /*"$i18n.t('editar')*/

    //10-02-2021
    otros:'Bestelakoak',
    restriccionHorarios:'Ordutegien murrizketa',
    restriccionHorariosDesc: "Restringir algunas franjas horarias(cerrado, lleno, no reparto...)",
    borrar: 'Ezabatu',
    restriccion: "Murrizketa", 
    nMaximoPedidos: "Gehienezko eskaera kopurua",
    cerrarFranja: "Zerrenda itxi",
    limitePedidos: "Eskaera kopuruaren muga",
    loSentimosSuNegocioNoTieneContratadoEsteModulo: "Sentitzen dugu, zure negozioak ez du modulu hau kontratatua",
    numeroPedidosPermitidos: "Baimendutako eskaera kopurua",
    estaSeguroDeQueDeseaEliminarEstaRestriccion: "Ziur zaude murrizketa hori ezabatu nahi duzula?",
    siBorrarRestriccion: "Bai, ezabatu murrizketa",
    loSentimosParaAccederAEsteModuloNecesitaActivarLaConfiguracion: "Sentitzen dugu, modulu honetara sartzeko konfigurazioa aktibatu behar duzu",
    costeSinIVA: "BEZik gabeko kostua",
    exportarContabilidad: "Esportatu kontabilitatea",

    //11.3.2021
    importeIVA: "BEZ zenbatekoa",

    //17.3.2021
    pasarAPreparacion: "Prestakuntzara pasatu",
    pasarAPreparados: "Prestakinetara pasatu",
    pasarAEnReparto: "Banaketara pasatu",
    finalizarPedido: "Amaitu eskaera",
    //Tener en cuidado con los espacios, ya que son los espacios Braille
    domicilioActivado: "‏‏‎DOMICILIO⠀ACTIVADO",
    domicilioDesactivado: "DOMICILIO⠀DESACTIVADO",
    recogerActivado: "RECOGER⠀ACTIVADO",
    recogerDesactivado: "RECOGER⠀DESACTIVADO",

    //
    conDetalles: "con detalles",
    zonasRepartoActivadas: 'ACTIVADAS⠀',
    zonasRepartoDesactivadas: 'DESACTIVADAS⠀',
    siEliminarCategoria: "Sí, eliminar categoría",
    confirmaEliminarCategoria: "¿Está seguro de que quiere eliminar esta categoría?",
    pedidoPreparado: "Pedido preparado",
    configuracionParaLaImportacionExportacionDeDatosDeSage: "Configuración para la importación/exportación de datos de Sage",
    enEstaPantallaSeConfiguranLosCodigosDeLasCuentas: "En esta pantalla se configuran los códigos de las cuentas",
    formadosPor3Digitos: 'formados por 3 dígitos',
    estosSonNecesariosParaConfigurarLasCuentasContables: "Estos son necesarios para configurar las cuentas contables",
    alEditarUnCodigoRelacionadoConUnaCuentaContableYaExistente: "Al editar un código relacionado con una cuenta contable ya existente",
    todoCambioQueSeProduzcaSobreEsteAfectaraTambienALaPropiaCuenta: "todo cambio que se produzca sobre este afectará también a la propia cuenta",
    aContinuacionSeListaranLasCuentasDeTipo: "A continuación se listarán las cuentas de tipo",
    gastoMinuscula: "gasto",
    paraQue: "para que",
    asocieMinuscula: "asocie",
    ventaMinuscula: "venta",
    unaParaSuPosterior: "una para su posterior",
    relacionEnSage: "relación en SAGE",
    seleccioneUnaCuenta: "Seleccione una cuenta",
    aDomicilio: "A domicilio",
    aRecoger: "A recoger",
    tipoDeZona: "Tipo de zona",
    seleccioneUnTipo: "Seleccione un tipo",
    kilometrosDelArea: "Kms del área",
    codigoEmpleado: "Codigo empleado",
    exportarReservas: "Exportar reservas",
    importacionSinqro: "Importación Sinqro",
    configuracionParaLaImportacionDeDatosDeSinqro: "Configuración para la importación de datos de Sinqro",
    pasarelaDePago: "Pasarela de pago",
    importeSinDescuento: "Importe sin descuento",
    desactivarZona: "Desactivar zona",
    activa: "ACTIVA",
    inactiva: "INACTIVA",
    exportarPdfConMateriasPrimasAsociadas: "Exportar PDF con materias primas asociadas",
    exportarExcelConMateriasPrimasAsociadas: "Exportar Excel con materias primas asociadas",

    //Pedidos archivados 18/05/21
    informePedidosDetalle:"Desglose de pedidos",
    informePedidos:"Informe de pedidos",
    tipoPago:"Forma de pago",
    tipoPedido:"Tipo de pedido",
    domicilio:"Envio a domicilio",
    recoger:"Recogida en local",
    pagoLocal:"Pago en local",
    otro:"Otro",

    //25/05/2021
    configuracionTurnos: "Configuración turnos",

    //2021/05/20
    estasSeguroDeImportarTusProductosASinqro: "¿Desea importar sus productos a Sinqro?",
    esteProcesoPuedeTardarVariosMinutos: "Este proceso puede tardar varios minutos.",
    siImportarConSinqro: "Sí, importar a Sinqro",
    estasSeguroDeDarDeBajaElProducto: "¿Desea dar de baja el producto?",
    podraDarloDeAltaEnUnFuturo: "Podrá darlo de alta en un futuro",
    siDarDeBaja: "Sí, dar de baja",
    estasSeguroDeDarDeAltaElProducto: "¿Desea dar de alta el producto?",
    podraDarloDeBajaEnUnFuturo: "Podrá darlo de baja en un futuro.",
    siDarDeAlta: "Sí, dar de alta",
    laImportacionTardara: "Importando... este proceso puede tardar varios minutos",
    importacionFinalizada: "Importación completada con exito",
    completo: "Completado",
    vale: "Vale",
    importarSinqro: "Importar Sinqro",
    importandoProductos: "La importación se está llevando a cabo en estos momentos...",
    generandoCarta: "Este es el último paso... Estamos generando su carta.",
    procesoFin: "El proceso se ha completado con éxito",
    procesoCompletado: "Proceso completado",
    yaFaltaPoco: "Ya falta poco...",
    estamosEnEllo: "Estamos trabajando en la importacion. Por favor, no recargue el navegador. " ,
    finProgres: "El progreso terminó con exito.",
    textoInfo:"Esta columna muestra el precio de compra con descuento (el cual se calcula a partir del precio sin IVA)",
    correosEnviados: "Bidali diren mezuak",
    correosEnviadosCorrectamente: "Mezuak behar bezala bidali dira.",
    errorAlEnviar: "Bidaltzean errorea",
    noSePudieronEnviarTodosLosCorreos: "Ezin izan dira mezu guztiak bidali:",
    errorInesperadoEnvioCorreos: "Espero gabeko errorea gertatu da. Mesedez, saiatu berriro geroago.",


    //07/06/2021
    valorRecuento: "Valor Recuento",
    
    //08/06/2021
    obligatorioEmail: "Obligatorio rellenar email",
    datosCliente : "Datos cliente",

    //11/06/2021
    recuerdeQueElHacerCobrosAvanzadosPuedeGenerarPequenosDescuadres:"Recuerde que el hacer cobros avanzados puede generar pequeños descuadres",
    yQue: "y que",
    losDescuentosDeLasVentasEstanAlCeroPorcientoDeIva:"los descuentos de las ventas estan al 0% de IVA",

    //16/06/2021
    totalValoresNegativos: "Total Valores Negativos",
    solamenteSeTieneEnCuentaValoresPositivos: "Solamente se tiene en cuenta valores positivos",
    totalValoresDiferencia: "Total Valores Diferencia",
    totalValoresDiferenciaDto: "Total Valores Diferecia Dto.",
    valorDiferencia: "Valor diferencia",
    valorDifereciaDto: "Valor diferencia dto.",
    precioDto: "Precio Dto.",

    //24/06/2021
    exportarMateriasPrimasAsociadasAEsteProducto: "Exportar materias primas asociadas a este producto",
    sinIVA: "Sin IVA",

    //MENÚS
    menus: "Menús",
    descripcionMenus: "Grupo de productos que se venden de forma conjunta",
    numeroDePlatos: "Número de platos que el cliente podrá elegir por cada plato:",
    platosTip1: "En esta pantalla se pueden crear los distintos platos que",
    platosTip2: "componen el menú para su posterior asignación con los productos.",
    productosPlatosTip: "En esta pantalla se pueden relacionar platos y productos para su posterior visualización en la carta.",
    plato: "Plato",
    platos: "Platos",
    primerPlato: "Primer plato",
    segundoPlato: "Segundo plato",
    tercerPlato: "Tercer plato",
    cuartoPlato: "Cuarto plato",
    quintoPlato: "Quinto plato",
    sextoPlato: "Sexto plato",
    seleccionaUnPlato: "Selecciona un plato",
    noPuedeDejarEnBlancoElNombreDeUnPlato: "No puede dejar en blanco el nombre de un plato",
    estaSeguroDeQueQuiereBorrarEstePlato: "¿Está seguro de que quiere borrar este plato?",
    seBorraranTodasLasAsociacionesDeProductosConElMismo: "Se borrarán todas las asociaciones de productos con el mismo",
    siEstoySeguro: "Sí, estoy seguro",
    estaSeguroDeQueQuiereDesvincularEsteProductoDelPlatoSeleccionado: "¿Está seguro de que quiere desvincular este producto del plato seleccionado?",
    dejaraDeFormarParteDelMenuDeFormaInstantanea: "Dejará de formar parte del menú de forma instantánea",
    noMostrarSuelto: "No mostrar suelto (sólo disponible en menús)",
    clonarMenu: "Klonatu menua",
    //29/07/2021
    totalPedidosDevueltos : "Nº de devoluciones",
    totalImportesDevueltos : "Total importe devuelto",

    //06/08/2021
    NoMostrarRecargasSaldo: "No mostrar recargas de saldo",
    //10/08/2021
    noMostrarDescuento: "No mostrar descuentos",
    //17/08/2021
    operarioApertura: "Operario apertura",
    aperturasPorOperarios: "Cuentas abiertas por operario",
    aperturasPorOperariosMinuscula: "cuentas abiertas por operario",
    aperturasOperarios : "Cuentas abiertas",
    productosPorAperturaDe: "Productos por apertura de",
    productosPorApertura:"Productos por apertura",
    facturasEmitidasMinuscula:"facturas emitidas",
    noMostrarDescuento: "No mostrar descuentos",

    //17/08/2021
    rangosDeMesas: "Rangos de mesas",
    agrupacionesDeMesasParaConsultarVentas: "Agrupaciones de mesas para consultar ventas",
    verUnInformeDeRangosDeMesas: "Ver informe de rangos de mesas",
    nuevoRangoMesa: "Nuevo rango mesa",
    mesaInicial: "Mesa inicial",
    mesaFinal: "Mesa final",
    noHayRangosDeMesasEnEsteTpv: "No hay rangos de mesas en este TPV",
    nombreRangoDeMesas: "Nombre rango de mesas",
    borrarRangoMesas: "Borrar rango de mesas",
    deseaEliminarEsteRangoDeMesas: "¿Desea eliminar este rango de mesas?",
    siBorrarEsteRangoDeMesas: "Sí, borrar este rango de mesas",
    ventasPorRangoDeMesas: "Ventas por rango de mesas",
    porRangoDeMesas: " por rango de mesas",
    numeroDeOperaciones: "Número de operaciones",
    precioMedioPorOperacion: "Precio medio por operación",
    propuestoParaCierre: "Propuesto para cierre",
    esteTicketHaSidoPropuestoParaSuCierreComaEstaUstedDeAcuerdo: "Este ticket ha sido propuesto para su cierre, ¿está usted de acuerdo?",
    siCerrarTicket: "Sí, cerrar ticket",
    propuestaDeCierreDeTicket: "Propuesta de cierre de ticket",
    noEstoyDeAcuerdo: "No estoy de acuerdo",
    ultimaRespuestaDelEquipoTecnico: "Última respuesta del equipo técnico",
    escribaAquiSuRespuesta: "Escriba aquí su respuesta",
    enviarRespuesta: "Enviar Respuesta",
    tienesTicketsPendientesDeCerrar: "Tienes tickets pendientes de cerrar",

    //26/08/2021
    exportarExcelDeTodosLosTickets: "Exportar Excel de todos los tickets",
    soloPuedesSacarInformesDeUnMesComoMaximo: "Solo puedes sacar informes de un mes como máximo",
    loSentimos: "Lo sentimos",
    noTienesNingunRangoDeMesasCreadoDeseasCrearUnRangoDeMesas: "No tienes ningun rango de mesas creado. ¿Deseas crear un rango de mesas?",
    siCrearUnRangoMesas: "Sí, crear un rango mesas",

    // 07/08/2021
    usuarioSinAcceso: "Su usuario no tiene acceso a este modulo",

    //08/09/21
    pedidosHoras: "Pedidos por horas",
    graficaPedidosHoras: "Gráfica que muestra el número de pedidos agrupado por tramo horario en el dia de hoy",

    //20/09/21
    personalizacionCarta: "Personalizacion de la Carta Online",
    personalizacionCarta: "Personaliza tu carta ",
    personalizacion: "Personalización",
    conLasOpcionesQueTeOfrecemos: "con las opciones que te ofrecemos",
    opcionesConfiguracion: "Opciones de configuración",
    vistaPrevia: "Vista previa",
    imagenCargando: "Imagen de carga",

    //21/09/21
    diagnosis: "Diagnosis",
    diagnosticoProductos : "Diagnóstico de productos",
    comprobacionProducts: "Comprobación de productos", 
    diagnosticarProductos: "Diagnosticar productos",
    productosSinRelacionEnElTpv : "¡Todo correcto!",
    pulseElBoton:"Pulse el botón deseado",
    paraRealizarDiagnosis : "para realizar la diagnosis",
    productoRelacionadoConTpv : "Relacionado en el TPV con",
    noTieneRelacion:"No tiene relacion",
    hayProductosSinRelacion:"Hay productos que no estan relacionados en el TPV",
    
    //20/09/21
    destacadosTitulo: "Titulo destacado",
    nuevoTitulo: "Nuevo titulo",
    tituloActual: "Titulo actual",

    //22/09/21
    textos: "Textos",

    //21/09/21
    facturas: "Facturas",
    facturasMinusculas: "facturas",
    facturacionGeneral: "Facturación general",
    deTodasLasSeries: " de todas las series",

    //29/09/21
    permisoBusinessGestion: "Lo sentimos. No tienes permiso para utilizar esta herramienta en el negocio actual",
    permisoUsuarioGestion: "Lo sentimos. Este negocio no cuenta con este módulo activado.",
    traduccion: "Traducción",
    traduccionDe: "Traducción de",
    idioma: "Idioma",
    losDescuentosDeLasVentasEstanAlCeroDeIva: "Los descuentos de las ventas están al 0% de iva",
    recuerdeQueAlRealizarCobrosAvanzadosLosComensalesSeAsignaranALaFormaDePagoEfectivo: "Recuerde que al realizar cobros avanzados los comensales se asignaran a la forma de pago efectivo",
    mapasYZonas: "Mapas y zonas",
    idiomas: "Idiomas",
    permisoControlIdiomas: "Lo sentimos, este negocio no cuenta con el control de idiomas activado.",
    idiomasCartaTip1: "Para activar o desactivar un idioma puedes hacer clic en los interruptores.",
    idiomasCartaTip2: "Para ordenar los idiomas en la carta, puedes utilizar el campo orden.",
    idiomasCartaTip3: "Los idiomas con un orden menor aparecerán primero.",
    excluirPrecioMedioMenu: "Excluir del precio medio los productos vendidos en menús",

    //19/06/2023
    conIvaDesglosado: "BEZ banakatuarekin",

    //10/01/24
    tolTipLogo: "Gehitu zure jatetxearen logotipoa agertu nahi duzun pantaila nagusian eta zure QR kodean. Tamaina gomendatua 90 x 90 px da.",
    tolTipFondo: "Gehitu kalitate handiko argazki bat zure menü QR gisa agertzea. Tamaina gomendatua 1280 x 1024 px da.",
    tolTipImagenProducto: "Gehitu kalitate handiko irudia zure produktua ikusgarri eta erakargarri erakusteko. Menuko produktuetarako, sortu bat berrirez eredua 500 x 500 pixel edo 12 cm x 12 cm daitekeen erresoluzioarekin.",
    tolTipNombreMostrado: "Idatzi hemen negozioaren erakusteko nahi duzun izena.",
    tolTipEmail: "Berezi eposta helbidea zure bezeroentzako.",
    tolTipTelefono: "Berezi telefonoa harremanetarako.",
    tolTipDescripcion: "Laburbildu zure jatetxea: eskaintzen duzun kontzeptua eta esperientzia.",
    tolTipDireccion: "Berezi jatetxearen helbidea hori hartzen duenaren karta.",
    tolTipPresentacion: "Idatzi neurri egokian ekintza deigarria zure bezeroek zure karta irekitzeko.",
    tolTipHorario: "Aurkeztu zure ordutegia edo partekatu informazio osagarria (oporrak, zerbitzu kanpoa...).",
    tolTipMostrarCategoriaDeBaja: "Kasilla bat markatzen baduzu, desgaitutako kategoriak agertuko dira, baina ez apareatuko zure kartearen barnean.",
    tolTipMostrarProductoDeBaja: "Kasilla bat markatzen baduzu, desgaitutako produktuak agertuko dira, baina ez apareatuko zure kartearen barnean.",
    tolTipTraducirCategoria: "Itzuli kategoriaren izenburua nahi duzun hizkuntzara.",
    tolTipConvertirCategoriaPadre: "Kategoriatu kategoria nagusian",
    tolTipOrdenCategorias: "Lehenik agertu nahi baduzu kategoria hau, zenbakia '1' izan beharko litzateke, eta hainbatetan jarraituz.",
    tolTipBajaCategoria: "Aukeratzen baduzu, kategoria hautatua ez da agertuko zure menu digitalean bezeroek hura eskuratu arte. Kategoriaren desgaitzeak honek ere dakar bereizketa, kategoria horretako espezifikoki produktu guztiak ere ikusgarri izango direla esan nahi du.",
    tolTipVerQr: "Sartu eta deskargatu zure karta QR kodea.",
    tolTipDisponibleProducto: "Markatu produktuaren eskuragarritasuna: Adierazi ea produktu bat eskuragarri dagoen ala ez zure kartearen barnean.",
    tolTipIdiomaProducto: "Hautatu produktua ere aurkezteko hizkuntza.",
    tolTipOrdenProducto: "Hautatu produktua agertu nahi duzun ordena kategoria hautatuan.",
    tolTipProductoDestacado: "Aukeratzen baduzu, produktua agertuko da karta hasieran nabarmendutako atalean. Azpimarratu produktu bereziak edo promozioak.",
    tolTipBaja: "Produktu hau ez da agertuko zure kartearen barnean (gaituta badago).",
    tolTipDisponible: "Gaitu botoia produktua saltzen dagoenean. Desgaitu 'Ez dago stock-en' produktua (existentziarik ez denean)''.",
    tolTipImagenCarga: "Irudia erakutsiko da segundo labur horietan zure karta kargatzen denean.",
    tolTipTituloDestacado: "Hemen definitu dezakezu nabarmendutako produktuen atalaren izenburua. Adibidez: 'Chef-en Aholkuak', 'Gure Salduenak' edo 'Galdu ezin dezakezu'.",
    tolTipIdiomaMateriaPrima: "Aukeratu zein hizkuntzatan ere aurkeztu nahi duzun lehengaia",
    guiaUsuario: "Erabiltzaile Gida",
    
    //12/03/24
    basesFree: "Oinarriak gehigarriak doan",
    extrasFree: "Oinarriak / Gehigarriak doan",
    tooltipBaseExtra: "OngietorriaBaseExtra: Se a base estiver ativada, ez du gehigarria doan gehitu. Gehigarria aktibatuta bada, doan kontatu ez da gehiagorik gehitzeko",

    exportar: "Esportatu",
    codigoBarras: "Barra-kodea",

    //WALLET
    passbooks: "Pasabideak",
    sharePassbooks: "Walletak partekatu",
    copyToClipboard: "Kopiatu arbelean",
    shareViaEmail: "Bidali e-postaz",
    shareViaWhatsapp: "Bidali WhatsApp bidez",
    copied: 'Arbelean kopiatu da',
    selectBusinessForWallet: 'Aukeratu Walletak bidali nahi dituzun negozioa',
    sendMethod: 'Bidaltzeko metodoa',
    share: "Bidali",
    sendAndSaveButton: 'Bai, bidali eta gorde',
    sendAndNoSaveButton: 'Ez, bidali eta ez gorde',
    titleSaveInfoModalText: 'Bezeroaren informazioa aldatu egin da. Informazio hau gorde nahi duzu?',
    verifyNumberText: 'Egiaztatu telefonoa',
    verifyEmailText: 'Egiaztatu e-posta',
    selectOption: 'Hautatu aukera bat',
    clipboardCopied: 'Arbelean kopiatu da',
    clipboardFailedToCopy: 'Arbela APIa ez dago eskuragarri nabigatzaile honetan.',
    enviarWallet: 'Wallet Bidali',
    confirmacionEnvioWallet: 'Wallet Bidalketaren Berrespena',
    confirmacionTextoEnviarWallet: 'Ziur zaude wallet-a bezero guztiei bidali nahi diezula?',
    mensajeConfirmacion: "Ezin da ekintza hau desegin eta bakarrik bidaliko zaie posta elektronikoa gehituta duten eta Barra kode bat duten bezeroei.",
    enviar: "Bidali",
    noHayCorreosElectronicos: "Ez dago posta elektronikorik.",
    ningunClienteConCorreoElectronico: "Ez da posta elektroniko konfiguratuta duen bezero bat ere aurkitu.",
    clientHasNoBarcode: "Bezeroak ez du barra kode bat ezarrita.",

    exportarCarta: "Karta esportatu",
    exportarSimplifiedExcel: "Esportatu Excel gisa (Goibururik gabe)",

    //13/11/24 NEW
    listadoTicketRepartidor: "Ticketak banatzailearen arabera",

    //GESTIÓN DE IMPUESTOS
    taxes: "Zergak",
    tax: "Zerga",
    gestionImpuestos: "Zergen Kudeaketa",
    administracionTiposTasas: "Administrazioa",
    administracionTiposTasasImpositivas: " motak eta zerga-tasak",
    agregarImpuesto: "Gehitu Zerga",
    taxRate: "Aplikatutako Zerga",
    taxDescription: "Deskribapena",
    taxType: "Zerga Mota",
    taxBoldType: "zergak",
    impuestoAplicadoEsCero: "Aplikatutako Zerga ezin da izan ",
    impuestoYaCreado: "Zerga hau dagoeneko existitzen da eta ezin da berriro sortu",

    //IMPORTAR CLIENTES 
    previewClientData: "Aurreikuspena",
    editarCliente: "Editatu bezeroa",
    importarData: "Datuak inportatu",
    importandoDatos: "Datuak inportatzen",
    preview: "Aurreikusi",
    importacionRealizada: "Inportazioa burututa",
    datosImportados: "Datuak behar bezala inportatu dira",
    confirmarImportacion: "Inportazioa baieztatu",
    seguroContinuarImportacion: "Ziur jarraitu nahi duzula? Ekintza hau atzeraezina da",

    //18/11/24-Update-Logo
    inserteImagen: "Irudi Txertatu",
    seleccioneArchivoImagen: "Aukeratu irudi-fitxategi bat",
    archivoDemasiadoGrande: "Fitxategia gehiegi handia da. Gehienez onartutako tamaina 5MB da",
    dimensionesExcedenLimite: " Irudiaren dimentsioek baimendutako muga (2000x2000px) gainditzen dute.",
    mensajeconfirmacion: "Egon zaitezke jada irudi egonkorra ordezkatzen. Gorde nahi al duzu?",
    botonGuardar: "Gorde",
    botonCancelar: "Ezeztatu",
    Guardado: "Gordeta",
    guardarOvisualizarLogo: "Ikusi edo gorde logoa",
    seleccionLogo: "Egin klik logo bat hautatzeko",
    volver: "Itzuli",
    noHayImagen: "Ez dago gordetako irudirik.",
    informacion: "Informazioa: ",
    tamaño: "Tamaina: ",
    dimensiones: "Dimentsioak: ",
    restriccionesLogo: "Logotipoaren muga:",
    tamañoMaximo: "Tamaina maximoa: ",
    dimensionesMaximas: "Dimentsio maximoak:  ",

    //13/12/24
    //ProductosNoRelacionados.NEW
    mensajeAviso: "Ziur al zaude PLUak automatikoki sortu nahi dituzula? Prozesu honek kode bat sortuko du produktu bakoitzarentzat eta tarifa bakoitzarentzat, ez badira konfiguratuak, eta automatikoki gordeko da.",
    mensajeAvisoSubProducto: "Ziur al zaude PLUak automatikoki sortu nahi dituzula? Prozesu honek kode bat sortuko du lehengai bakoitzarentzat, ez badira konfiguratuak, eta automatikoki gordeko da.",
    aviso: "Abisua!",
    generarPlu: "Automatikoki PLUs Sortu",
    botonAceptar: "Onartu",
    PLUsGenerados: "PLUak zuzenean sortuak!",
    errorGenerandoPLUs: "Errore bat PLUs sortzean",

    //21/01/2025
    nosmudamos: "Lekualdatzen ari gara!",
    noscambiamosaselfi: "Zure negozioak aurrerapauso handia eman du: orain Selfibar familiaren parte gara. Hemendik aurrera, konfigurazio eta kudeaketa guztiak Selfibarren egin ahal izango dituzu",
    irASelfibar: "Selfibarrera joan",

    barcodeUnico: "Barra kode bakarra",
    barcodeNecesarioSeActualizara: "Barra kodea beharrezkoa da eta eguneratuko da",

    barcodeUnico: "Barra-kode bakarra",
    barcodeNecesarioSeActualizara: "Ekintza honetarako barra-kodea beharrezkoa da eta bidaltzean edo arbelean kopiatzean bezero honentzat eguneratuko da.",

    //ListadomateriaPrima-Proveedor.
    //14/01/25
    verListado: "Lehengaia zerrenda",
    listadoMateriaPrimaProveedor: "Hornitzailearen lehengaiak zerrenda",
    noTiene: "Ez du ",
    esteProveedor: " hornitzaile honek",
    proveedor: "Fornitzailearen Izena:   ",
    precioAcordado: "Hornidarekin adostutako prezioa",
    porcentajeAcordado: "Adosutako ehunekoa",
    FiltrarPorEtiqueta: "Etiketaren arabera iragaz: ",
    precioAcordadoGuardadoCorrectamente: "Adosutako prezioa zuzen gorde da!",
    fijarprecio: "Prezioa ezarri ",
    preciofijado: "(Lehengaien prezioa ezartzea)",
    mensajePrecioFijado: "Lehengaien prezioa da ",
    explicacionFijarPrecio: "Aktibatzean, lehengaien prezioa eta beherapen ehunekoa ezarriko dira. Gastu berri bat egiten denean, ez dira prezioa edo beherapena aldatuko.",
    porcentajeAcordado: "Abisatzeko ehunekoa",
    porcentajeAcoradoGuardado: "Aldatutako ehunekoa. Zuzen gorde da!",
    SubproductoIncrementado: "Lehen materiala handitua",
    LosSubproductosSeHanIncrementado : "Ez da gastua egiaztatu ahal izan, izan ere, hornitzailearekin hitzartutako ehunekoaren gaineko prezio igoera detektatu da honako lehen materialetan",
    errorverificar: "Errorea egiaztatzen",
    MateriaPrimasIncremento:"Hurrengo lehen materialetan %5eko igoera erregistratu da: ",
    ConfirmacionGuardar: "Gorde nahi al duzu?",
    Elsubproducto: " Lehen materiala ",
    MensajeErrorVerificarTodo: "Ez da posible guztia egiaztatzea, izan ere, hurrengo gastuek lehen materialaren prezio igoera dute, hornitzailearekin hitzartutako ehunekoaren gainean",
    explicacionPorcentajeAcordado: "Hau da hornitzailearekin hitzartutako ehunekoa, lehen materialen prezioa kontrolatzeko gastua egin aurretik.",
    generarBusinessHash: "Operarientzako URLa sortu",
    enlaceFicharTurnosOperario: "Txandak fitxatzeko eta kontsultatzeko sarbidea",
    enlaceFicharTurnosOperarioDescripcion: "Enpresako langileek TPVko kredentzial berberak erabiliz saioa has dezakete beren txanden hasiera eta amaiera erregistratzeko, baita azken 14 txandak eta haien iraupenak kontsultatzeko ere.",

};


// WEBPACK FOOTER //
// ./src/language/euskera.js